export const MOCK_PREDICTOR_VARIABLES = {
  li_gender: ['others', 'Female', 'Male', 'mask', null],
  li_income: [
    'others',
    '100K_150',
    'LT_30K',
    '50K_74K',
    'GT_150K',
    '75K_99K',
    '30K_50K',
    'mask',
    null,
  ],
  li_age: ['others', 'gt_65', '55_64', '45_54', '35_44', '25_34', '18_24', 'mask', null],
  domain: [
    'others',
    'aniwatch.to',
    'governmentjobs.com',
    'fmoviesz.to',
    'aniwave.to',
    'omahasteaks.com',
    '9animetv.to',
    'wcofun.tv',
    'hoopshype.com',
    'de.tynt.com',
    'geediting.com',
    'i.liadm.com',
    'animesuge.to',
    'methstreams.com',
    'thejigsawpuzzles.com',
    'gomovies.sx',
    'eliteprospects.com',
    'sherwin-williams.com',
    'ftw.usatoday.com',
    'ewg.org',
    'zorox.to',
    'thedebrief.org',
    'myflixerz.to',
    'mmajunkie.usatoday.com',
    'sportsbookwire.usatoday.com',
    'cotopaxi.com',
    'fnbo.com',
    'havertys.com',
    'hdtoday.tv',
    'creaders.net',
    'm.beforeitsnews.com',
    'newsmax.com',
    'vettix.org',
    'the.crackstreams.ws',
    'dailyvoice.com',
    'pawrade.com',
    'empirereportnewyork.com',
    'rycamelot.com',
    'carnival.com',
    'lifeisgood.com',
    'news.creaders.net',
    'bulkapothecary.com',
    'experteditor.com.au',
    'viewfromthewing.com',
    'chattanoogan.com',
    'academic.oup.com',
    'anix.to',
    'especiallyyours.com',
    'beforeitsnews.com',
    'soap2day.tf',
    'theclemsoninsider.com',
    'soaper.tv',
    'paulayoung.com',
    'tax.ny.gov',
    'evite.com',
    'twinkl.com',
    't.co',
    'surlatable.com',
    'classicfirearms.com',
    'americanthinker.com',
    'golfweek.usatoday.com',
    'cmegroup.com',
    'movieshd.watch',
    'nodq.com',
    'ads.yieldmo.com',
    'deltafaucet.com',
    'mysavings.com',
    'playerauctions.com',
    'marleylilly.com',
    'racer.com',
    'listchallenges.com',
    'yachtworld.com',
    'ads.pubmatic.com',
    'boobychristmas.com',
    '2tdd.adj.st',
    'bflix.to',
    'flixhq.to',
    'plowhearth.com',
    'packerswire.usatoday.com',
    'massagebook.com',
    'news.usni.org',
    'thewalletguru.com',
    'internetweathermap.com',
    'tigernet.com',
    'chicksaddlery.com',
    'dvidshub.net',
    'understandingwar.org',
    'movies7.to',
    'wishtv.com',
    'moviesjoy.is',
    'savewith.coupons',
    'wvmetronews.com',
    'charitynavigator.org',
    'goku.sx',
    'tampabay.com',
    'supercheats.com',
    'onedhs.tn.gov',
    'soap2dayx.to',
    'wcofun.org',
    'theflixer.tv',
    'nautica.com',
    'duckswire.usatoday.com',
    'gcaptain.com',
    'wdef.com',
    'wolverineswire.usatoday.com',
    'retrogames.cc',
    'ugawire.usatoday.com',
    'primewire.mx',
    'watchseries.mx',
    'currentobituary.com',
    'brickset.com',
    'allevents.in',
    'quitt.net',
    'places.singleplatform.com',
    'sflix.to',
    'wahjobqueen.com',
    'amerisbank.com',
    'm.epicsports.com',
    'jamanetwork.com',
    'lewrockwell.com',
    'moviestowatch.tv',
    'slopegame.io',
    'appgamer.com',
    'time-time.net',
    'foxnews.com',
    'worldofreel.com',
    'buckeyeswire.usatoday.com',
    'massageenvy.com',
    'schooljobs.com',
    'passionatepennypincher.com',
    'dolphinswire.usatoday.com',
    'aliceandolivia.com',
    'pinterest.com',
    'zips.com',
    'lionswire.usatoday.com',
    'southalabama.edu',
    'soap2day.rs',
    'klkntv.com',
    'videogameschronicle.com',
    'moodfabrics.com',
    'hardcoregamer.com',
    'coastal24.com',
    'fairfaxcounty.gov',
    'allthingsworn.com',
    'healthychildren.org',
    'apnetv.to',
    'bodyartforms.com',
    'steelerswire.usatoday.com',
    'hawkeyeswire.usatoday.com',
    'pzdeals.com',
    'puppyfinder.com',
    'laytonsportscards.com',
    'airandspaceforces.com',
    'losmovies.id',
    'fmovies.to',
    'youtube.com',
    'movies2watch.tv',
    'farmasius.com',
    'solarmovie.pe',
    '270towin.com',
    'billoreilly.com',
    '9anime.to',
    'bearswire.usatoday.com',
    'hurawatch.cc',
    'vikingswire.usatoday.com',
    'longhornswire.usatoday.com',
    'readcomiconline.li',
    'broncoswire.usatoday.com',
    'bengalswire.usatoday.com',
    'fightingirishwire.usatoday.com',
    'celebdirtylaundry.com',
    'golocalprov.com',
    'hdtoday.cc',
    'cowboyswire.usatoday.com',
    'msn.com',
    'wbbjtv.com',
    'crn.com',
    'lindaikejisblog.com',
    'fieracosmetics.com',
    'theeagleswire.usatoday.com',
    'flixwave.to',
    'ctotrk.com',
    'moviesjoy.plus',
    'georgiamls.com',
    'stonybrook.edu',
    'theramswire.usatoday.com',
    'soonerswire.usatoday.com',
    'allbud.com',
    'dallasisd.org',
    'bannerbank.com',
    'f2movies.to',
    'gematsu.com',
    'insidelacrosse.com',
    'kubotausa.com',
    'lake-link.com',
    'ringsidecollectibles.com',
    'dopebox.to',
    '123moviesfree.mx',
    'rcwilley.com',
    'chiefswire.usatoday.com',
    'about.usps.com',
    'wmdt.com',
    'visitflorida.com',
    'brownswire.usatoday.com',
    'linkedin.com',
    'tickets.enchantchristmas.com',
    'billswire.usatoday.com',
    'chelseasmessyapron.com',
    'frequentmiler.com',
    'flixtorz.to',
    'ev01.sx',
    'aviewfrommyseat.com',
    'southernplate.com',
    'ancient-origins.net',
    'ordering.roundtablepizza.com',
    'gatorswire.usatoday.com',
    'lsu.edu',
    'scotusblog.com',
    'origin-www.lids.com',
    'indeed.com',
    'titanswire.usatoday.com',
    'wp1-ext.usps.gov',
    'localflavor.com',
    'commanderswire.usatoday.com',
    'freestufffinder.com',
    'sweepsadvantage.com',
    'equinenow.com',
    'njmls.com',
    'aldoshoes.com',
    'factorypure.com',
    'amac.us',
    'flixhd.cc',
    'home-home.org',
    'designfiles.co',
    'oneblood.org',
    'trojanswire.usatoday.com',
    'floridatrend.com',
    'saintswire.usatoday.com',
    'login.ny.gov',
    'erepairables.com',
    'spellsbee.com',
    'publications.aap.org',
    'dmv.colorado.gov',
    'shu.edu',
    'himovies.sx',
    'broward.edu',
    'giantswire.usatoday.com',
    'moviesjoyhd.to',
    'knitpicks.com',
    'rabbitstream.net',
    'fx-cryptonews.com',
    'myarkansaslottery.com',
    'tasteofcinema.com',
    'mountsinai.org',
    'telegraphherald.com',
    'cointrackers.com',
    'rollerfuneralhomes.com',
    'dtnpf.com',
    'cornhuskerswire.usatoday.com',
    'reddit.com',
    'bowl.com',
    'perfumania.com',
    'baseball.epicsports.com',
    'match.prod.bidr.io',
    'goya.com',
    'armyrecognition.com',
    'aggieswire.usatoday.com',
    'dailymemphian.com',
    'coloradosun.com',
    'clarksvillenow.com',
    'movieorca.com',
    'touchdownwire.usatoday.com',
    'foreverwickcandle.com',
    'ninerswire.usatoday.com',
    'lbs.crosswordle.cc',
    'epi.org',
    's.scope.ly',
    'novelcool.com',
    'store.myfundraisingplace.com',
    'fmovies.llc',
    'hurawatch.bz',
    'brecks.com',
    'pantherswire.usatoday.com',
    'soap2dayhd.com',
    'etonline.com',
    'amawaterways.com',
    'newsearch.pro',
    'towerfcu.org',
    'spartanswire.usatoday.com',
    'usacoinbook.com',
    'middlesexbank.com',
    'putlocker.pe',
    'trendygolfusa.com',
    'thesolitaire.com',
    'pokeflix.tv',
    'ut.edu',
    'mangareader.to',
    'pta.waynecounty.com',
    'mcmenamins.com',
    'firstinspires.org',
    'librefutboltv.com',
    'silencershop.com',
    'publicsurplus.com',
    'dar.org',
    'localconditions.com',
    'exeterfinance.com',
    'nar.realtor',
    'tapinto.net',
    'draftwire.usatoday.com',
    'poppinpopcornonline.com',
    'flexjobs.com',
    'bistromd.com',
    'us232.dayforcehcm.com',
    'wabcradio.com',
    'deals.consumerbags.com',
    'bollywoodhungama.com',
    'fmovies.ink',
    'myflixer.pw',
    'hunt4freebies.com',
    'badgerswire.usatoday.com',
    'universalfurniture.com',
    '9anime.se',
    'tastefullysimple.com',
    'igourmet.com',
    'hdtoday.se',
    'fmoviesto.cc',
    'my.bible.com',
    'colonialproperties.com',
    'overwolf.com',
    'baorgd.com',
    'discoverlosangeles.com',
    'patriotswire.usatoday.com',
    'taxprof.typepad.com',
    '123moviestv.net',
    'abc6.com',
    'sflix.se',
    'sixerswire.usatoday.com',
    'wwaytv3.com',
    'primewire.ph',
    'linkedupradio.com',
    'jefferson.kyschools.us',
    'seconduse.com',
    'musichq.pe',
    'people.com',
    'ncat.edu',
    'letflix.tv',
    'seahawkswire.usatoday.com',
    'usatoday.com',
    'allsides.com',
    'secondipity.com',
    'myflixerx.to',
    'swatchseries.is',
    'bancfirst.bank',
    'm.made-in-china.com',
    'wholelottayum.com',
    'lbcc.edu',
    'dupontregistry.com',
    'pullapart.com',
    'charter97.org',
    'ww7.ssoap2day.to',
    'yuppow.com',
    'ctvisit.com',
    'stjohns.edu',
    'mauinow.com',
    'perryssteakhouse.com',
    'nittanylionswire.usatoday.com',
    'raiderswire.usatoday.com',
    'watchwrestlingup.org',
    'pasco.k12.fl.us',
    'newsday.co.tt',
    'obitmichigan.com',
    'coolmathgames.com',
    'cineb.rs',
    'theyeshivaworld.com',
    'thedomesticrebel.com',
    'mokwheel.com',
    'celticswire.usatoday.com',
    'gogoanime.me',
    'powersports.honda.com',
    'zacks.com',
    'inova.org',
    'en.y2mate.is',
    'contests.covers.com',
    'actvid.rs',
    'clubwyndham.wyndhamdestinations.com',
    'coloradobuffaloeswire.usatoday.com',
    'pastorrick.com',
    'cinego.tv',
    'uchealth.org',
    'miamiandbeaches.com',
    'coastal.edu',
    'yeahmovies.to',
    'nihaojewelry.com',
    'secure.coastal24.com',
    'revolvermag.com',
    'flixhq.id',
    'warriorswire.usatoday.com',
    'stereophile.com',
    'u.openx.net',
    'thenation.com',
    'bestnfl.crackstreams.me',
    'read.the-pennisaver.com',
    'visitnj.org',
    'cobbk12.org',
    'simcosplay.com',
    'movies2watch.to',
    'mzamin.com',
    'showboxmovies.net',
    'wordlearchive.com',
    'consumerbags.com',
    'gympart.com',
    'amazingribs.com',
    'classifiedads.com',
    'americanmilitarynews.com',
    'themahjong.com',
    'gomovies.ms',
    'luckyonesie.com',
    'equibase.com',
    'en1.y2mate.is',
    'countcalculate.com',
    'kodiakcakes.com',
    'diario.mx',
    'onlinekhabar.com',
    'volswire.usatoday.com',
    'nbadraft.net',
    'tax.colorado.gov',
    'stlcc.edu',
    'aap.org',
    'flixtor.id',
    'fbox.to',
    'bigislandnow.com',
    'idahosports.com',
    'trustonefinancial.org',
    'easysplashbuilder.net',
    'resultsmx.com',
    'lundsandbyerlys.com',
    'celebratingthesoaps.com',
    'freemoviesfull.net',
    'iup.edu',
    'topviewnyc.com',
    'jobs.foundever.com',
    'upcounsel.com',
    '6movies.net',
    'centerpointenergy.com',
    'shop.tacticalshit.com',
    'ourlads.com',
    'calculatehours.com',
    'thejasminebrand.com',
    'broadwayinchicago.com',
    'crawfordcountynow.com',
    'icsc.com',
    'randomsaladgames.pubfinity.com',
    'wordstream.com',
    'whiteoakpastures.com',
    'poppornday.com',
    'uncfsu.edu',
    'futbollibre.futbol',
    'gurneys.com',
    'tailgatermagazine.com',
    'farrow-ball.com',
    'shopcgx.com',
    'myfederalretirement.com',
    'fmovies.ps',
    'servers-minecraft.net',
    'hvcc.edu',
    '34heritage.com',
    'secure.bannerbank.com',
    'newsweek.com',
    'manofmany.com',
    'beckett.com',
    'easyhits4u.com',
    '1sttix.org',
    'coltswire.usatoday.com',
    'tinyzonetv.se',
    'heymovies.to',
    'elcaribe.com.do',
    'calcxml.com',
    'waynecounty.com',
    'gifts.getconsumerchoice.com',
    'lonestar.edu',
    'watch32.id',
    'mymotherlode.com',
    'farm.ewg.org',
    'wordhurdle.co',
    'quicktransportsolutions.com',
    'shop.catholicsupply.com',
    'winnoise.com',
    'purlsoho.com',
    'pinstripesnation.com',
    'exploregeorgia.org',
    'iberkshires.com',
    'fnafgame.io',
    'kgmi.com',
    'attackertv.so',
    'mastgeneralstore.com',
    'umms.org',
    'thefalconswire.usatoday.com',
    'v.vfgte.com',
    'slopegame.online',
    'city-journal.org',
    'rolltidewire.usatoday.com',
    'texanswire.usatoday.com',
    'kvrr.com',
    'serieshd.watch',
    'swatchseries.mx',
    'daiyafoods.com',
    'm.yelp.com',
    'windandweather.com',
    'alfred.com',
    'traffic.americanmilitarynews.com',
    'fanstory.com',
    'freemoviesfull.cc',
    'watchprowrestling.co',
    'cameradecision.com',
    'nogravitygames.com',
    'freemoviesfull.com',
    'freemovies2021.com',
    'flixhq.pe',
    'millercenter.org',
    'kimcartoon.li',
    'watchwrestling.wtf',
    'hothardware.com',
    'livelingua.com',
    'rheem.com',
    'mtishows.com',
    'aosom.com',
    'solfors.com',
    'putlockernew.vc',
    'gizmos.explorelearning.com',
    'news.bk.com',
    'southfront.press',
    'sahmreviews.com',
    'kissonline.com',
    'turkish123.org',
    'mattamyhomes.com',
    'rods.com',
    'flights.flyfrontier.com',
    'rutgerswire.usatoday.com',
    'tarheelswire.usatoday.com',
    'auburnwire.usatoday.com',
    'ffa.org',
    'go.lifehackin.com',
    'phhmortgage.com',
    'forums.jokersupdates.com',
    'highpoint.edu',
    'nmcdn.us',
    'brownedbutterblondie.com',
    'miladycima.com',
    'nrel.gov',
    'snackcrate.com',
    'sites.touchstonecrystal.com',
    'jewishworldreview.com',
    'ingoodtaste.com',
    'studentscholarships.org',
    'allrecipes.com',
    'reflexmath.com',
    'thehuddle.com',
    'whiznews.com',
    'sourpussclothing.com',
    'fngames.io',
    'thundervalleyresort.com',
    'funnyand.com',
    'retrogames.cz',
    '123moviesfree.bond',
    'shop.smallpetselect.com',
    'dragzine.com',
    'wordwaffle.org',
    'us.p448.com',
    'imf.org',
    'freemovieswatch.tv',
    'ammonnews.net',
    'hudsonyardsnewyork.com',
    'wng.org',
    'talkai.info',
    'watchmovies.nz',
    'cookie-clicker2.com',
    'usatodayhss.com',
    'reformjudaism.org',
    'fox21online.com',
    'amzn.to',
    'first.bank',
    'franchiseball.com',
    'clemsonwire.usatoday.com',
    'ads.us.e-planning.net',
    'lsutigerswire.usatoday.com',
    'eroticasearch.net',
    'andrewsfcu.org',
    'sierraclub.org',
    'hawksmotorsports.com',
    'pixibeauty.com',
    'lensa.com',
    'soldiersystems.net',
    'etf.wi.gov',
    'myflixertv.to',
    'kids.marleylilly.com',
    'video.creaders.net',
    'examcompass.com',
    'quora.com',
    'divicast.com',
    'seagullbook.com',
    'offthepress.com',
    'prospect.org',
    'onetag-sys.com',
    'scfta.org',
    'politika.rs',
    'worldatoz.org',
    'kjmotorsports.com',
    'punchbowl.com',
    'tnpaws.tn.gov',
    'nativenewsonline.net',
    'apkaward.com',
    'quordle-wordle.com',
    'admissions.rutgers.edu',
    'cuone.org',
    'teacherplanet.com',
    'rutgers.edu',
    'ent.creaders.net',
    'hdwatch.tv',
    'movieapne.co',
    'my.masseyservices.com',
    '3rdcc.org',
    'boulgerfuneralhome.com',
    'dickmorris.com',
    'cornel1801.com',
    'dordlewordle.com',
    'ewtn.com',
    'unicef.org',
    'dining.umich.edu',
    'weber.com',
    '101lifehacks.com',
    'beatyeyes.xyz',
    'chatgptfree.ai',
    'firstambank.com',
    'protothema.gr',
    'morgan.edu',
    'tikmovies.com',
    'byramhealthcare.com',
    'mecu.com',
    'yummyextensions.com',
    'hometownnewsnow.com',
    'jymsupplementscience.com',
    'towerfcuonline.org',
    'npr.org',
    'cibng.ibanking-services.com',
    'greatvaluevacations.com',
    'm.riverbender.com',
    'arc018.to',
    'ldsbookstore.com',
    'job.myjobhelper.com',
    'wwvv.ssoap2day.to',
    'thumbnet.net',
    'maxpreps.com',
    'zoechip.com',
    'dallassymphony.org',
    'searchengineland.com',
    'vvc.edu',
    '123moviesfree.buzz',
    'zoechip.cc',
    'moviestowatch.cc',
    'perfectlypriscilla.com',
    'knfilters.com',
    'heartlandamerica.com',
    'moaa.org',
    'bandondunesgolf.com',
    'calstrs.com',
    'travelinsurance.com',
    'bigislandvideonews.com',
    'prosoccerwire.usatoday.com',
    'bonchon.com',
    'tampaairport.com',
    'fee.org',
    'employment.pa.gov',
    'zulily.com',
    'gmovies.cc',
    'uberhumor.com',
    'shoprentone.com',
    'rd.bizrate.com',
    'link.surlatable.com',
    'stats.oarc.ucla.edu',
    'walnutstreettheatre.org',
    'converter9.quora-wiki.com',
    '123moviesto.pw',
    'majorgeeks.com',
    'axs.com',
    'eurooptic.com',
    'jaguarswire.usatoday.com',
    'michigan.org',
    'onlineraceresults.com',
    'live-tennis.eu',
    'chinapress.com.my',
    'cuadrashop.com',
    'lemaxcollection.com',
    'wgu.edu',
    'dealsfinders.blog',
    'gamersdecide.com',
    'myflixer.gs',
    'connectionsgame.com',
    'littledebbie.com',
    'bingewatch.to',
    '9movies.top',
    'alphaforexs.com',
    'yoursportsedge.com',
    'visitcherokeenc.com',
    'avid.com',
    'quordlewordle.com',
    'twu.edu',
    'm.nihaojewelry.com',
    'crochet.com',
    'bmcc.cuny.edu',
    'indastro.com',
    'nypost.com',
    'catholicculture.org',
    'honolulumagazine.com',
    'cdphe.colorado.gov',
    'lhm.org',
    'myflixer.is',
    'karger.com',
    'dianomi.com',
    'jaynestars.com',
    'cureus.com',
    'screenrant.com',
    'go.besttechtrend.com',
    'ravenswire.usatoday.com',
    'wordlewebsite.com',
    'locations.massageenvy.com',
    'mysticstamp.com',
    'mcw.edu',
    'hiphoplately.com',
    'watchapne.co',
    'chevyhardcore.com',
    '1moviestv.com',
    'singtaousa.com',
    'booty-christmas.com',
    'rwu.edu',
    'cs.thomsonreuters.com',
    'amazon.com',
    'doorcountydailynews.com',
    'yesyoucan.com',
    'ameris.biz-business.online-banking-services.com',
    '2kmovie.cc',
    'lostiempos.com',
    'roundtablepizza.com',
    'skidmore.edu',
    'volocars.com',
    'ebtshopper.com',
    'accessmedicine.mhmedical.com',
    'bmi.com',
    'cardswire.usatoday.com',
    'peoples-law.org',
    'apps.explorelearning.com',
    'hgtc.edu',
    'dutchbulbs.com',
    'soap2day.pe',
    'jpauto.com',
    'laurainthekitchen.com',
    'awesomejelly.com',
    'travelalaska.com',
    'papas-games.io',
    'sportclips.com',
    'genesishealthclubs.com',
    'bluegrasstoday.com',
    'morganlewis.com',
    'brill.com',
    'claycord.com',
    'hartvillehardware.com',
    'watchseries.im',
    'trendingdailygadget.com',
    'aeroroutes.com',
    'watchseriesstream.com',
    '1movieshd.com',
    'usembassy.gov',
    'aestheticsymbols.me',
    'filmlicious.net',
    'airmedcarenetwork.com',
    'royalgazette.com',
    'watchgang.com',
    'vid.vidoomy.com',
    'charlottemotorspeedway.com',
    'finfeatherfur.com',
    'fordmuscle.com',
    'myforecast.co',
    'movies2watch.cc',
    'thestar.com.my',
    'meridian.allenpress.com',
    'advantiscu.org',
    'chargerswire.usatoday.com',
    'jobs.peopleready.com',
    'watchseries.pe',
    'sportshd.sx',
    'sunnyskyz.com',
    'wwoz.org',
    'go.craftsy.com',
    'chagrinvalleysoapandsalve.com',
    'fa-mag.com',
    'schoolcounselor.org',
    'graphicaudio.net',
    'steelstacks.org',
    'go.topconsumerguide.com',
    'hostthetoast.com',
    'catalog.pac-audio.com',
    'citationmachine.net',
    'frostburg.edu',
    '9tv.co.il',
    'stacker.com',
    'danielsoper.com',
    'pittsburghmagazine.com',
    'meatingplace.com',
    'armandhammer.com',
    'papaspizzeria.io',
    'app.hauntpay.com',
    'putlocker.sb',
    'certainteed.com',
    'freemovieswatch.net',
    'introvertdear.com',
    'unsolvedcasefiles.com',
    'restaurantware.com',
    'zzzcode.ai',
    'soap-2day.to',
    'streetmusclemag.com',
    'wrestlingnetwork.in',
    'isd742.org',
    'middleeasteye.net',
    'extendoffice.com',
    'writerscafe.org',
    'xmovies.ws',
    'sugarapron.com',
    'grocefuneralhome.com',
    'nfpa.org',
    'chilis.com',
    'healthywallet.co',
    'dopebox.se',
    '24naijamuzic.com',
    'hanson.net',
    'bluebell.com',
    'myevergreen.com',
    'manticgames.com',
    'hdtoday.so',
    'watchfreemovi.es',
    'vsu.edu',
    'better-notyounger.com',
    'fmovies.hn',
    'stallionesearch.com',
    'gmtgames.com',
    'gradecalc.info',
    'pafootballnews.com',
    'in.usembassy.gov',
    'twigby.com',
    'gunnar.com',
    'bid-2-buy.com',
    'putlocker.gy',
    'nielsenmassey.com',
    'organicallyaddison.com',
    'cushmanwakefield.com',
    'yoturkish.app',
    '123serieshd.ru',
    'livefaucet.com',
    'cerritos.edu',
    'mrmoneymustache.com',
    'westwinddi.com',
    'emmys.com',
    'atlantamagazine.com',
    'coinappraiser.com',
    'flashpoint.govictory.com',
    'blog.easybreathe.com',
    'direct.mit.edu',
    'afpaction.actcentr.com',
    'hawaiianelectric.com',
    'pacificlife.com',
    'bluezones.com',
    'wcbi.com',
    'wccbcharlotte.com',
    'coinmaster-free-spins.net',
    'top.consumerbags.com',
    'portseattle.org',
    'yesmovies.mn',
    'bernzomatic.com',
    'hagleywest.com',
    'easyhits4u.net',
    'app.appsflyer.com',
    'research.aota.org',
    'ymovieshd.com',
    'kpcu.com',
    'ticketmaster.com',
    'easeus.com',
    'everwilde.com',
    'learninga-z.com',
    'pizzakit.com',
    'huntstand.com',
    'franciscanhealth.org',
    'content.overwolf.com',
    'surforsound.com',
    'revisionskincare.com',
    'sparknotes.com',
    'besttechtrend.com',
    'kikkomanusa.com',
    'tempeunion.org',
    '123moviesfree.fan',
    'arcticfoxhaircolor.com',
    'bidnetdirect.com',
    'losmovies.ru',
    'ev01.cc',
    'newsroom.gy',
    'techlicious.com',
    'wietingfuneralhome.com',
    'raceentry.com',
    'autospies.com',
    'washoecounty.gov',
    'turners.com',
    'omgflix.com',
    'theflixer.se',
    'helpwithmybank.gov',
    'pos.org',
    'minted.com',
    'runnerspace.com',
    'aeofmiami.com',
    'goarch.org',
    'prophecynewswatch.com',
    'tuskegee.edu',
    'findunclaimedassets.info',
    'aerosmith.com',
    'catalog.lsu.edu',
    'insurancebusinessmag.com',
    'world-nuclear.org',
    'projectmanager.com',
    'maa.org',
    'imis.counseling.org',
    'login.openathens.net',
    'v2.y2mate.bz',
    'trtnation.com',
    'papas-freezeria.io',
    'nextierbank.com',
    'reelz.com',
    'taylorvilledailynews.com',
    'millicanpecan.com',
    'jdrf.org',
    'midwestern.edu',
    'railwayage.com',
    'sso.newsmax.com',
    'lawprofessors.typepad.com',
    'bluebonnetnews.com',
    'bitsandpieces.com',
    'paulkfuneralhome.com',
    'evesun.com',
    'broker-instaforex.com',
    'marywood.edu',
    'facebook.com',
    'hd.crichdlivecricket.cc',
    'journals.ametsoc.org',
    'collegehillshonda.com',
    'counseling.org',
    'bandondunesgolfshop.com',
    '123movies.com.pk',
    'fairwayindependentmc.com',
    'best-minecraft-servers.co',
    'mibor.com',
    'duplicolor.com',
    'masterpiecearms.com',
    'spam.com',
    'lifehackin.com',
    'oge.mit.edu',
    'gameplay.tips',
    'dinamalar.com',
    'baldwinhardware.com',
    'rustysoffroad.com',
    'nyafilmer.gg',
    'stockinvest.us',
    'enginelabs.com',
    'tobincenter.org',
    'themoviebox.net',
    'cambridgeday.com',
    'philstar.com',
    'pridemobility.com',
    'gundamkitscollection.com',
    'finance.creaders.net',
    'copera.org',
    'riverbender.com',
    'il.usembassy.gov',
    'diamondcoretools.com',
    'athene.com',
    'vivaterra.com',
    'ymovies.cc',
    'lebanondebate.com',
    'hennepinhealthcare.org',
    'spglobal.com',
    'portal.shu.edu',
    'rachaelrayshow.com',
    'thinkingoutsidethecage.org',
    'sflix.is',
    'motorsportswire.usatoday.com',
    'soap2day.faith',
    'wiredwatts.com',
    'zimmermann.com',
    'huramovies.to',
    'solarmovies.ms',
    'a.1turkish123.com',
    'warroad.com',
    'en.wikipedia.org',
    'uspharmacist.com',
    'za.investing.com',
    'butlerperformance.com',
    'pubs.aip.org',
    'laundryview.com',
    'hsmo.org',
    'abccolumbia.com',
    'drawdown.org',
    'iwae.com',
    'templehealth.org',
    'aranwoollenmills.com',
    'teachsundayschool.com',
    'novelhi.com',
    'citizenfreepress.com',
    'kensh.xyz',
    'kicdam.com',
    'thecommonsenseshow.com',
    'aniwatchtv.to',
    'dnr.wa.gov',
    'f2movies.mx',
    'hdobox.se',
    'lbc.edu',
    'partyfixx.co',
    'oldelpaso.com',
    'louslist.org',
    'rezortricks.com',
    'dordlegame.io',
    'twitter.com',
    'rfa.org',
    'asicminervalue.com',
    'watchseriestv.top',
    'lsxmag.com',
    'daily-healthtips.com',
    'moviekids.tv',
    'ais-inc.com',
    'afflat3e1.com',
    'basketball.epicsports.com',
    'hawaiimagazine.com',
    'janome.com',
    'spin.com',
    'rayanworld.com',
    'experiences.hiltonhonors.com',
    'seafoodsource.com',
    'boston-theater.com',
    'fitchburgstate.edu',
    'pirlotvhd.online',
    'churchmouseyarns.com',
    'indus.travel',
    'taylorswift2048.io',
    '123moviesgo.ac',
    'wwn.ssoap2day.to',
    'newbrunswick.rutgers.edu',
    'lmmountford.com',
    'saundersdwyer.com',
    'billingsreport.com',
    'morningagclips.com',
    'theapplicantmanager.com',
    'skinkraft.com',
    'passnaplexnow.com',
    'widener.edu',
    'pennymustard.com',
    'bloomsbury.com',
    'moviecracker.net',
    'baileigh.com',
    'sidroth.org',
    'dhl.com',
    'visitmaryland.org',
    'volcanodiscovery.com',
    'careers.wa.gov',
    'nextdaypets.com',
    'christianchat.com',
    '123moviesfree.cafe',
    'careers.peraton.com',
    'cinema.dinamalar.com',
    'tapplastics.com',
    'jppast.info',
    'springhillnursery.com',
    'bw.edu',
    'win-waste.com',
    'aoa.org',
    'drudgereport.com',
    'gamesradar.com',
    'westminsterco.gov',
    '41nbc.com',
    'doorcountypulse.com',
    'midway.org',
    'quordlewordle.io',
    'highlandcountypress.com',
    'socalskateshop.com',
    'neogen.com',
    'tunoticiapr.com',
    'villapalmarcancun.com',
    '247sports.com',
    'cctvsecuritypros.com',
    'beverlyhillscarclub.com',
    'floretflowers.com',
    'soundandvision.com',
    'jcpenneyoptical.com',
    'littlechapel.com',
    'bonginoreport.com',
    'us.fotileglobal.com',
    'cinebox.cc',
    'santiago2023.org',
    'ratopati.com',
    'hot-tent.com',
    'mwwire.com',
    'vineyardgazette.com',
    'espn.com',
    'facs.org',
    'camdencounty.com',
    'twsn.net',
    '123series.id',
    'news.virginia.edu',
    'generalmills.com',
    'nxn.runnerspace.com',
    'checkcity.com',
    'coolsymbols.io',
    'kissasian.lu',
    'govictory.com',
    'aseaofred.com',
    'emoticonstext.com',
    'imvu.com',
    'northcountrypublicradio.org',
    'praywithme.com',
    'dunejewelry.com',
    'songmics.com',
    'ragalahari.com',
    'earlychildhood.marylandpublicschools.org',
    'olmic.xyz',
    'outbrain-d.openx.net',
    'wbu.com',
    'levisstadium.com',
    'thefishatlanta.com',
    'gamezebo.com',
    'lovecomplement.com',
    'lovetobeinthekitchen.com',
    'weareblood.org',
    'chihealth.com',
    'equineline.com',
    'atg.wa.gov',
    'nubsnob.com',
    'gleam.io',
    'handcuffwarehouse.com',
    'crohnscolitisfoundation.org',
    'backforseconds.com',
    '804-vt.c3tag.com',
    'wiche.edu',
    'charlestonsouthern.edu',
    'amtrakvacations.com',
    'steynonline.com',
    'jobs.irs.gov',
    'sonicstadium.org',
    'draftsharks.com',
    'bankiowa.bank',
    'ohchr.org',
    'btlaw.com',
    'cutesymbols.net',
    'destinationgettysburg.com',
    'safoodbank.org',
    'theartsherpa.com',
    'napa-net.org',
    'carminesnyc.com',
    'icing.com',
    'joeletchenguns.com',
    'cruisemummy.co.uk',
    'cracksat.net',
    'batesville.com',
    'auction.housingworks.org',
    '99dealdrops.com',
    'cedarmemorial.com',
    'boardingarea.com',
    'swapalease.com',
    'tmz.com',
    'whoi.edu',
    'stonemaiergames.com',
    'familyradio.org',
    'dailystoic.com',
    'activityhero.com',
    'coffeebeancorral.com',
    'ashpublications.org',
    'alfredstate.edu',
    'ashrae.org',
    'jetswire.usatoday.com',
    'google-bidout-d.openx.net',
    'crackap.com',
    'forwoobatan.com',
    'freestufffrenzy.com',
    'symbolcopy.com',
    'bucswire.usatoday.com',
    'octordlewordle.org',
    'feridies.com',
    'member.mibor.com',
    'transum.org',
    'candle-lite.com',
    'futbolfullenvivo.nl',
    'carolinapottery.com',
    'globaltimes.cn',
    'thedarkroom.com',
    'mcfarlane.com',
    'web.fmoviesto.site',
    'go.consumerbags.com',
    'musichq.cc',
    'communityphone.org',
    'innerdimensiontv.com',
    'onbeing.org',
    'plotaroute.com',
    'sportskeeda.com',
    'bowen-donaldson.com',
    'bcbs.com',
    'noblecollection.com',
    'wvwv.ssoap2day.to',
    'livestream-sports.net',
    'bestgreenpowder.com',
    'huntingtonbeachca.gov',
    'sph.umich.edu',
    'my.firstinspires.org',
    'quiltingdigest.com',
    'meetbeagle.com',
    'wrestlingjunkie.usatoday.com',
    'tribalfootball.com',
    'online.ucpress.edu',
    'ajc.org',
    'seagate.com',
    'shoporangetheory.com',
    'wolfhomeproducts.com',
    'unep.org',
    'mamacheaps.com',
    'xenonpro.com',
    'vividstormscreen.com',
    'podcastone.com',
    'televisionseries.co',
    'theflightdeal.com',
    'getautoair.com',
    'newyorkcitytheatre.com',
    'happyhomefairy.com',
    'aecf.org',
    'apea.com',
    'sharepointdiary.com',
    'hkej.com',
    'reptifiles.com',
    'edhub.ama-assn.org',
    'lvms.com',
    'realflame.com',
    'smcm.edu',
    'sweetrecipeas.com',
    'vidplay.site',
    'bkfc.com',
    'ospreypublishing.com',
    'patrioticviralnews.com',
    'carepatron.com',
    'tvbiwi.cc',
    'wne.edu',
    'seriesturcastv.to',
    'journals.humankinetics.com',
    'viainfo.net',
    'rheumatology.org',
    'galaxytreats.com',
    'subscribestar.com',
    'bristolmotorspeedway.com',
    'developer.nvidia.com',
    'lennyfac.es',
    'myaccount.stlmsd.com',
    'csmd.edu',
    'converter8.quora-wiki.com',
    'dogadoptions.franklincountyohio.gov',
    'rts.i-car.com',
    'capitalhumanesociety.org',
    'mountain-archery.com',
    'yardbarker.com',
    'scam-detector.com',
    'trolleytours.com',
    'chicago-theater.com',
    'monasteryicons.com',
    'soccer.epicsports.com',
    'ich.unesco.org',
    'sandjengines.com',
    'minecraft-schematics.com',
    'backblaze.com',
    'swagperformanceparts.com',
    'denverhealth.org',
    'theawesomer.com',
    'centralmilling.com',
    'robbinsbrothers.com',
    'flixtor.win',
    'livescience.com',
    'leelalicious.com',
    'y2mate.tools',
    'ltu.edu',
    'caramelandcashews.com',
    'filepuma.com',
    'foothealthfacts.org',
    'offroadwarehouse.com',
    'pfisterfaucets.com',
    'chsbuffalo.org',
    'mrsc.org',
    'ambitenergy.com',
    'oxiclean.com',
    'hood.com',
    'crichd.live',
    '123moviestv.me',
    'hr.com',
    'solarmovies.win',
    'soundphysicians.com',
    'easybib.com',
    'gadgetslaboratory.com',
    'greeka.com',
    'vatire.com',
    'petbridge.org',
    'watchwrestling.gg',
    'legacy.com',
    'goucher.edu',
    'qsys.com',
    'bossshotshells.com',
    'montefiore.org',
    'octordlegame.io',
    'my.lonestar.edu',
    'en.touhouwiki.net',
    'miloyale.com',
    'razorbackswire.usatoday.com',
    'stchlibrary.org',
    'thegarageplanshop.com',
    'sandiacasino.com',
    'tarot.com',
    'vgchartz.com',
    'czboyer.com',
    'wynter.com',
    'lislecorp.com',
    'momentummag.com',
    'vidplay.lol',
    'mhsrv.com',
    'munchkinfreebies.com',
    'heardleunlimited.io',
    'ccpl.org',
    'hometownapparel.com',
    'mica.edu',
    'health.creaders.net',
    'housedigest.com',
    'whiskyliquorstore.com',
    'onegoldenthread.com',
    'cookingwithnonna.com',
    'shopstyle.it',
    'pulse.sullivansupply.com',
    'diabetesjournals.org',
    'farmshow.com',
    'lawhelp.org',
    'sk.sagepub.com',
    'cooper.edu',
    'racetothewh.com',
    'asq.org',
    'go.reference.com',
    'snyderfuneralhome.com',
    'classicstoday.com',
    'eps.schoolspecialty.com',
    'waka.com',
    'read.dukeupress.edu',
    'theduckwebcomics.com',
    'glarysoft.com',
    'lifeinnorway.net',
    'treperformance.com',
    'visitwilliamsburg.com',
    'usyouthsoccer.org',
    'texas-standard.com',
    'larkinmortuary.com',
    'fiskerati.com',
    'brightroomy.com',
    'foodchallenges.com',
    'soapspoiler.com',
    'msdprojectclear.org',
    'storypoint.com',
    'natlawreview.com',
    'burgerking.scholarsapply.org',
    'incendar.com',
    'us231.dayforcehcm.com',
    'the-sun.com',
    'iboysoft.com',
    'alvernia.edu',
    'parmamunicourt.org',
    'georgialegalaid.org',
    'putthison.com',
    'gold-eagle.com',
    'aniwave.tv',
    'jergels.com',
    'ccrane.com',
    'ch-match.taboola.com',
    'whatgoesaroundnyc.com',
    'watchseries.mn',
    'rocketswire.usatoday.com',
    'iranianuk.com',
    'icahn.mssm.edu',
    'fmovieshd.vip',
    'smith-nephew.com',
    'article.the-pennysaver.com',
    'urologyhealth.org',
    'pomoly.com',
    'aveva.com',
    'ikeahackers.net',
    'realinvestmentadvice.com',
    'ppa.com',
    'garage-organization.com',
    'elheraldo.co',
    'ensegundos.do',
    'bayhealth.org',
    'colonial-settlers-md-va.us',
    'moviesjoy.mx',
    'mybyramhealthcare.com',
    'vethelpdirect.com',
    'papersowl.com',
    'eventdecordirect.com',
    'finance.rutgers.edu',
    'emmasdiary.co.uk',
    'dyslexiaida.org',
    'beta.allbreedpedigree.com',
    'illinoisairteam.net',
    'dor.sd.gov',
    'affresh.com',
    'carrollscove.com',
    'las-vegas-theater.com',
    'iherb.com',
    'bchl.ca',
    'garagebaggerstereo.com',
    'favhd.net',
    'printavo.com',
    'awkwardfamilyphotos.com',
    'himovies.rs',
    'drury.edu',
    'overcomingobstacles.org',
    'rmi.org',
    'weavergame.org',
    'onlinebootycall.com',
    'thatviralfeed.com',
    'vidstream.to',
    'bestofstreamingmovies.com',
    'ottolenghi.co.uk',
    'recipess.website',
    'brecksgifts.com',
    'srvcdn4.2convert.me',
    'industrynet.com',
    'artgalleryfabrics.com',
    'fadavispt.mhmedical.com',
    'stardewvalley.net',
    '9anime.pe',
    'srvcdn14.2convert.me',
    'mhcc.edu',
    'career4.successfactors.com',
    'ratemyprofessors.com',
    'newyorker.com',
    'okcthunderwire.usatoday.com',
    'signupgenius.com',
    'blog.creaders.net',
    'horizonservices.com',
    'srvcdn8.2convert.me',
    'cabo.garzablancaresort.com',
    'seattlecenter.com',
    'member.legion-aux.org',
    'inspiredclosets.com',
    'palawhelp.org',
    'acc.org',
    'srvcdn11.2convert.me',
    'srvcdn3.2convert.me',
    'projectcasting.com',
    'joinonelove.org',
    'yankee.org',
    'burtonsgrill.com',
    'srvcdn1.2convert.me',
    'worldchangers.org',
    'srvcdn12.2convert.me',
    'emjcd.com',
    'zimmerbiomet.com',
    'kicks96.com',
    'journals.biologists.com',
    'srvcdn10.2convert.me',
    'dayair.org',
    'ssj.mp3juice.blog',
    'pdza.org',
    'digest.creaders.net',
    'srvcdn13.2convert.me',
    'woojr.com',
    'townofbarnstable.us',
    'premastrologer.com',
    'wwvape.com',
    'ambfurniture.com',
    'unctad.org',
    'srvcdn9.2convert.me',
    'proweb.myersinfosys.com',
    'landproequipment.com',
    'foodnetwork.com',
    'worldmark.wyndhamdestinations.com',
    'commercehub.com',
    'japanhaul.com',
    'registrar.gmu.edu',
    'valleymls.com',
    'hamptonroads.myactivechild.com',
    'thegoodinside.com',
    'moneycrashers.com',
    'auburnschools.org',
    'ama.org',
    'saltwire.com',
    'youth.gov',
    'app.gopassage.com',
    'shop.zulily.com',
    'aila.org',
    'echo360.com',
    'srvcdn5.2convert.me',
    'wexinc.com',
    'instrumentl.com',
    'mmashare.fullfight.video',
    'billwinston.org',
    'si.com',
    'balldrop.com',
    'bennington.edu',
    'pressboxonline.com',
    'l.instagram.com',
    'whatsyourgrief.com',
    'm.kidshoo.com',
    'triplefatgoose.com',
    'klty.com',
    'scaquarium.org',
    '560theanswer.com',
    '1v1lolunblocked.com',
    'wxxv25.com',
    'rakuten.com',
    'legendsoflearning.com',
    'srvcdn2.2convert.me',
    'sensory-smart.com',
    'mortgagemarketguide.tabrasa.io',
    'welovedoggos.com',
    'futbollibre.nu',
    'electric-saver.com',
    'srvcdn15.2convert.me',
    '123moviesfree.wine',
    'pandrama.tv',
    'en.m.wikipedia.org',
    'engineering.virginia.edu',
    'system.gotsport.com',
    'realmofdarkness.net',
    'wolftrap.org',
    'andrewhudsonsjobslist.com',
    'mssu.edu',
    'ohsaa.boxcast.com',
    'bedderway.com',
    'accessdubuquejobs.com',
    'readfrom.net',
    'consumer.secure.amerisbank.com',
    'mossadams.com',
    'thinkbluela.com',
    'pleated-jeans.com',
    'nbaa.org',
    'nc.gov',
    'get-direction.com',
    'njsba.com',
    'estafeta.com',
    'mp3juice-70.mp3juice.tools',
    'museumofflight.org',
    'watchkin.com',
    'quizony.com',
    'record.revenuenetwork.com',
    'indexmundi.com',
    'stcc.edu',
    'rupahealth.com',
    'gonglue.us',
    'cheer.epicsports.com',
    'tomsguide.com',
    '0gomovies.gd',
    'lotteryusa.com',
    'iggm.com',
    'fboxtv.com',
    'gunsmagazine.com',
    'mashupmom.com',
    'collegesportswire.usatoday.com',
    'vegoutmag.com',
    'gmanetwork.com',
    'jax.org',
    'tennisnow.com',
    'slideserve.com',
    'factable.com',
    'salary.com',
    'rojadirectatvhd.com',
    'lebronwire.usatoday.com',
    'furkids.org',
    'app.shu.edu',
    'gamewatcher.com',
    'shelbycountypost.com',
    'retrobowlcollege.org',
    'shopversona.com',
    'standardnews.com',
    'socialcatfish.com',
    '3000toys.com',
    'pm.officeally.com',
    'topconsumerguide.com',
    'dothanpd.org',
    'srvcdn6.2convert.me',
    'tr-usual.com',
    'yts.gy',
    'analogplanet.com',
    'kassamall.com',
    'ravelry.com',
    'familytalktoday.com',
    'sewmodernbags.com',
    'tinytap.com',
    'masseyservices.com',
    'uk.usembassy.gov',
    'guidehouse.com',
    'alchemybikes.com',
    'shopcosmicglobe.com',
    'manhattan.institute',
    'petcarerx.com',
    'lucky32.com',
    'temple.dinamalar.com',
    'tnachieves.org',
    'wnax.com',
    'aacap.org',
    'farmflavor.com',
    'mply.io',
    'getyourholidayon.com',
    'traceup.com',
    'dunyanews.tv',
    'watch32.ru',
    'app.betterfuture.com',
    'la-match.taboola.com',
    'reviewerscience.com',
    'sierraloaded.sl',
    'annsbridalbargains.com',
    'zanderins.com',
    'oflaherty-law.com',
    'jbprince.com',
    'obits.taylorvilledailynews.com',
    'banyantreatmentcenter.com',
    'scu.edu',
    'chea.org',
    'asmedigitalcollection.asme.org',
    'anl.gov',
    'naot.com',
    'crichd.com',
    'topconsumer.review',
    'philadelphia-theater.com',
    'mitpress.mit.edu',
    'performance.ford.com',
    'go.creativecrochetcorner.com',
    'app.breezy.hr',
    'mask',
    null,
  ],
  dma: [
    'others',
    'new york, ny',
    'los angeles, ca',
    'philadelphia, pa',
    'chicago, il',
    'washington, dc (hagerstown, md)',
    'atlanta, ga',
    'seattle-tacoma, wa',
    'dallas-ft. worth, tx',
    'boston, ma-manchester, nh',
    'phoenix, az',
    'detroit, mi',
    'san francisco-oakland-san jose, ca',
    'houston, tx',
    'tampa-st petersburg (sarasota), fl',
    'minneapolis-st. paul, mn',
    'denver, co',
    'miami-ft. lauderdale, fl',
    'charlotte, nc',
    'orlando-daytona beach-melbourne, fl',
    'portland, or',
    'indianapolis, in',
    'raleigh-durham (fayetteville), nc',
    'cleveland-akron (canton), oh',
    'sacramento-stockton-modesto, ca',
    'pittsburgh, pa',
    'baltimore, md',
    'san antonio, tx',
    'greenville-spartanburg, sc-asheville, nc-anderson, sc',
    'kansas city, mo',
    'columbus, oh',
    'nashville, tn',
    'hartford & new haven, ct',
    'austin, tx',
    'salt lake city, ut',
    'cincinnati, oh',
    'milwaukee, wi',
    'las vegas, nv',
    'san diego, ca',
    'chattanooga, tn',
    'buffalo, ny',
    'albany-schenectady-troy, ny',
    'providence, ri-new bedford, ma',
    'st louis_mo',
    'grand rapids-kalamazoo-battle creek, mi',
    'harrisburg-lancaster-lebanon-york, pa',
    'greensboro-high point-winston salem, nc',
    'the bronx_ny',
    'queens_ny',
    'norfolk-portsmouth-newport news,va',
    'st. louis, mo',
    'west palm beach-ft. pierce, fl',
    'new orleans, la',
    'omaha, ne',
    'louisville, ky',
    'birmingham, al',
    'memphis, tn',
    'jacksonville, fl',
    'albuquerque-santa fe, nm',
    'mobile, al-pensacola (ft. walton beach), fl',
    'oklahoma city, ok',
    'madison, wi',
    'knoxville, tn',
    'dayton, oh',
    'des moines-ames, ia',
    'columbia, sc',
    'rochester, ny',
    'green bay-appleton, wi',
    'flint-saginaw-bay city, mi',
    'honolulu, hi',
    'jackson, ms',
    'tulsa, ok',
    'wilkes barre-scranton, pa',
    'little rock-pine bluff, ar',
    'lexington, ky',
    'richmond-petersburg, va',
    'ft. myers-naples, fl',
    'tucson (sierra vista), az',
    'cedar rapids-waterloo-iowa city & dubuque, ia',
    'lincoln & hastings-kearney, ne',
    'toledo, oh',
    'colorado springs-pueblo, co',
    'syracuse, ny',
    'portland-auburn, me',
    'wichita-hutchinson, ks',
    'charleston, sc',
    'waco-temple-bryan, tx',
    'baton rouge, la',
    'fresno-visalia, ca',
    'savannah, ga',
    'boise, id',
    'florence-myrtle beach, sc',
    'spokane, wa',
    'champaign & springfield-decatur,il',
    'roanoke-lynchburg, va',
    'harlingen-weslaco-brownsville-mcallen, tx',
    'huntsville-decatur (florence), al',
    'wilmington, nc',
    'springfield, mo',
    'el paso, tx',
    'rockford, il',
    'burlington, vt-plattsburgh, ny',
    'reno, nv',
    'springfield-holyoke, ma',
    'eugene, or',
    'savonburg_ks',
    'lansing, mi',
    'charleston-huntington, wv',
    'south bend-elkhart, in',
    'sioux falls(mitchell), sd',
    'greenville-new bern-washington, nc',
    'tri-cities, tn-va',
    'fargo-valley city, nd',
    'johnstown-altoona, pa',
    'tallahassee, fl-thomasville, ga',
    'corpus christi, tx',
    'ft. smith-fayetteville-springdale-rogers, ar',
    'ft. wayne, in',
    'paducah, ky-cape girardeau, mo-harrisburg-mount vernon, il',
    'yakima-pasco-richland-kennewick, wa',
    'binghamton, ny',
    'la crosse-eau claire, wi',
    'columbus, ga',
    'augusta, ga',
    'davenport,ia-rock island-moline,il',
    'peoria-bloomington, il',
    'traverse city-cadillac, mi',
    'shreveport, la',
    'youngstown, oh',
    'macon, ga',
    'evansville, in',
    'montgomery (selma), al',
    'salisbury, md',
    'albany, ga',
    'santa barbara-santa maria-san luis obispo, ca',
    'wausau-rhinelander, wi',
    'tyler-longview(lufkin & nacogdoches), tx',
    'sioux city, ia',
    'duluth, mn-superior, wi',
    'lafayette, la',
    'monterey-salinas, ca',
    'columbia-jefferson city, mo',
    'gainesville, fl',
    'anchorage, ak',
    'erie, pa',
    'jackson, tn',
    'bakersfield, ca',
    'rochester, mn-mason city, ia-austin, mn',
    'topeka, ks',
    'medford-klamath falls, or',
    'charlottesville, va',
    'lafayette, in',
    'minot-bismarck-dickinson(williston), nd',
    'chico-redding, ca',
    'bangor, me',
    'palm springs, ca',
    'beaumont-port arthur, tx',
    'terre haute, in',
    'idaho falls-pocatello, id',
    'missoula, mt',
    'lubbock, tx',
    'columbus-tupelo-west point, ms',
    'amarillo, tx',
    'henrico_va',
    'yuma, az-el centro, ca',
    'biloxi-gulfport, ms',
    'utica, ny',
    'port saint lucie_fl',
    'joplin, mo-pittsburg, ks',
    'clarksburg-weston, wv',
    'odessa-midland, tx',
    'wichita falls, tx & lawton, ok',
    'panama city, fl',
    'dorchester_ma',
    'bend, or',
    'piscataway_nj',
    'billings, mt',
    'elmira, ny',
    'monroe, la-el dorado, ar',
    'mantua_nj',
    'hattiesburg-laurel, ms',
    'harrisonburg, va',
    'sherman, tx-ada, ok',
    'rapid city, sd',
    'dothan, al',
    'watertown, ny',
    'alexandria, la',
    'west bloomfield_mi',
    'grand junction-montrose, co',
    'butte-bozeman, mt',
    'vaughn_wa',
    'bluefield-beckley-oak hill, wv',
    'saint augustine_fl',
    'city of saint peters_mo',
    'fuquay-varina_nc',
    'quincy, il-hannibal, mo-keokuk, ia',
    'wheeling, wv-steubenville, oh',
    'cheyenne, wy-scottsbluff, ne',
    'parkersburg, wv',
    'greenwood-greenville, ms',
    'laredo, tx',
    'mankato, mn',
    'ft  washington_md',
    'marquette, mi',
    'mt  pleasant_sc',
    'negley_oh',
    'lima, oh',
    'clinton township_mi',
    'lake charles, la',
    'north hollywood_ca',
    'abilene-sweetwater, tx',
    'jonesboro, ar',
    'bowling green, ky',
    'eureka, ca',
    "lee's summit_mo",
    'zanesville, oh',
    'cordova_tn',
    'twin falls, id',
    'saint charles_mo',
    "coeur d'alene_id",
    'casper-riverton, wy',
    'clarkton_nc',
    'hoffman_nj',
    'saint johns_fl',
    'laurelton_nj',
    'hillsborough_nj',
    "land o' lakes_fl",
    'mililani town_hi',
    'newton center_ma',
    'saint charles_il',
    'egg harbor_nj',
    'clifton park_ny',
    'great falls, mt',
    'west chester_oh',
    'ottumwa, ia-kirksville, mo',
    "o'fallon_mo",
    'deptford_nj',
    'waterford_mi',
    'san angelo, tx',
    'meridian, ms',
    'helena, mt',
    "o'fallon_il",
    'redford_mi',
    'saint joseph_mi',
    'hyde park_ma',
    'ft  pierce_fl',
    'fairbanks, ak',
    'victoria, tx',
    'marquette_mi',
    'peachtree corners_ga',
    'cassville_nj',
    'la grange_ga',
    'parrish_fl',
    'ponte vedra_fl',
    'northridge_ca',
    'vestal_ny',
    'wellesley hills_ma',
    'parsippany_nj',
    'presque isle, me',
    'saint joseph_mo',
    'fleming island_fl',
    'donnelsville_oh',
    'lawrence_nj',
    "'ewa beach_hi",
    'cementon_pa',
    'kingwood_tx',
    'ca\u00f1on city_co',
    'elkhorn_ne',
    'rayland_oh',
    'la jolla_ca',
    'drayton_sc',
    'saint marys_pa',
    'sylmar_ca',
    'commerce_mi',
    'juneau, ak',
    'neptune city_nj',
    'randolph township_nj',
    'suitland_md',
    'warrington_pa',
    'sparta_nj',
    'wakefield_ri',
    'north platte, ne',
    'lithia_fl',
    'roslindale_ma',
    'university park_pa',
    'middleboro_ma',
    'east setauket_ny',
    '\u2018aiea_hi',
    'rockville_ct',
    'howell township_nj',
    'saint johns_mi',
    'mt  dora_fl',
    'hallandale_fl',
    'green hill_tn',
    'cortlandt manor_ny',
    'panorama city_ca',
    'huntingdon valley_pa',
    'manhattan_ny',
    'okatie_sc',
    'princeton junction_nj',
    'saint albans_wv',
    'belle vernon_pa',
    'kinwood_tx',
    'wynnewood_pa',
    'mask',
    null,
  ],
  city: [
    'others',
    'New York',
    'Seattle',
    'Brooklyn',
    'Phoenix',
    'Chicago',
    'Los Angeles',
    'Philadelphia',
    'Houston',
    'Atlanta',
    'Miami',
    'Dallas',
    'San Antonio',
    'Denver',
    'Washington',
    'Detroit',
    'Minneapolis',
    'Portland',
    'Charlotte',
    'St Louis',
    'Las Vegas',
    'Indianapolis',
    'The Bronx',
    'Queens',
    'Columbus',
    'Orlando',
    'Austin',
    'Tampa',
    'Pittsburgh',
    'Buffalo',
    'Chattanooga',
    'Cleveland',
    'Cincinnati',
    'Omaha',
    'San Diego',
    'San Francisco',
    'Greenville',
    'Arlington',
    'Boston',
    'Raleigh',
    'Saint Paul',
    'Kansas City',
    'Rochester',
    'Albany',
    'Jacksonville',
    'San Jose',
    'Fort Lauderdale',
    'Sacramento',
    'Lexington',
    'Springfield',
    'Tucson',
    'Richmond',
    'Louisville',
    'Milwaukee',
    'Columbia',
    'Madison',
    'Memphis',
    'Newark',
    'Lincoln',
    'Fort Worth',
    'Albuquerque',
    'Alexandria',
    'Ashburn',
    'Colorado Springs',
    'Baltimore',
    'Birmingham',
    'Wilmington',
    'Salt Lake City',
    'Dayton',
    'Providence',
    'Brookhaven',
    'Knoxville',
    'Savonburg',
    'New Orleans',
    'Nashville',
    'Aurora',
    'Fayetteville',
    'Honolulu',
    'El Paso',
    'Lancaster',
    'West Sacramento',
    'Jackson',
    'Grand Rapids',
    'Oklahoma City',
    'Baton Rouge',
    'Long Beach',
    'Tulsa',
    'Greensboro',
    'Oakland',
    'Staten Island',
    'Troy',
    'Concord',
    'Jersey City',
    'Charleston',
    'Riverside',
    'Mobile',
    'Lafayette',
    'Durham',
    'Marietta',
    'Mesa',
    'Gainesville',
    'Medford',
    'Corpus Christi',
    'Middletown',
    'Cambridge',
    'Virginia Beach',
    'Clarksville',
    'Katy',
    'St. Petersburg',
    'Franklin',
    'Little Rock',
    'Henderson',
    'Decatur',
    'Auburn',
    'Wichita',
    'Irvine',
    'Spring',
    'Salem',
    'Ann Arbor',
    'Canton',
    'Hollywood',
    'Alpharetta',
    'Pompano Beach',
    'West Palm Beach',
    'Fremont',
    'Bloomington',
    'Plano',
    'Farmington',
    'Boise',
    'Frisco',
    'Tallahassee',
    'Toledo',
    'Norfolk',
    'Reno',
    'Overland Park',
    'Belleville',
    'Silver Spring',
    'Norwich',
    'Woodbridge',
    'Wayne',
    'Scottsdale',
    'Littleton',
    'Spokane',
    'Fort Wayne',
    'Fresno',
    'Trenton',
    'Lawrenceville',
    'Burlington',
    'Montgomery',
    'Athens',
    'Olympia',
    'Vancouver',
    'Lansing',
    'Lebanon',
    'Winston-Salem',
    'Akron',
    'Chandler',
    'Milford',
    'Sarasota',
    'Oxford',
    'Round Rock',
    'Rock Hill',
    'Monroe',
    'Worcester',
    'Bakersfield',
    'Lakewood',
    'Glendale',
    'Ocala',
    'Syracuse',
    'Gilbert',
    'Bradenton',
    'Cary',
    'Duluth',
    'Myrtle Beach',
    'Fairfax',
    'Anderson',
    'Plymouth',
    'Kissimmee',
    'Tacoma',
    'Florence',
    'Anaheim',
    'Pasadena',
    'Eugene',
    'Rockville',
    'Lena',
    'York',
    'Avon',
    'Bellevue',
    'West Linn',
    'Rockford',
    'Laurel',
    'Fairfield',
    'Naples',
    'Des Moines',
    'Warren',
    'Stockton',
    'Manchester',
    'Huntsville',
    'Cumming',
    'Peoria',
    'Dover',
    'Fort Collins',
    'Henrico',
    'Anchorage',
    'Harrisburg',
    'Allentown',
    'Hayward',
    'Sanford',
    'Savannah',
    'Brandon',
    'Fort Myers',
    'Dublin',
    'Cape Coral',
    'Cypress',
    'Covington',
    'Irving',
    'Augusta',
    'Beaverton',
    'Plainfield',
    'Olathe',
    'Tempe',
    'Lakeland',
    'Bristol',
    'Lake Worth',
    'Carrollton',
    'Reading',
    'Boca Raton',
    'Spring Hill',
    'Dearborn',
    'Corona',
    'Port Saint Lucie',
    'Pensacola',
    'Englewood',
    'Marion',
    'Mansfield',
    'Bedford',
    'Hudson',
    'Summerville',
    'New Port Richey',
    'Erie',
    'Smyrna',
    'Germantown',
    'Denton',
    'Green Bay',
    'Allen',
    'Greenwood',
    'Charlottesville',
    'Watertown',
    'Clinton',
    'Garland',
    'Fargo',
    'Manassas',
    'Westminster',
    'Lawrence',
    'Greensburg',
    'College Station',
    'Kings Mountain',
    'Dorchester',
    'Roanoke',
    'Murfreesboro',
    'Georgetown',
    'Midland',
    'Hampton',
    'Everett',
    'Meridian',
    'Davenport',
    'Milton',
    'Clearwater',
    'Evansville',
    'Melbourne',
    'Piscataway',
    'Fontana',
    'Kalamazoo',
    'Wauchula',
    'Schenectady',
    'Bellingham',
    'Salisbury',
    'Mantua',
    'Appleton',
    'Novi',
    'Sterling Heights',
    'Brighton',
    'New Castle',
    'Sioux Falls',
    'Apex',
    'Hamilton',
    'Brunswick',
    'Dubuque',
    'Wake Forest',
    'Santa Ana',
    'McKinney',
    'Asheville',
    'Hyattsville',
    'Lubbock',
    'Mount Vernon',
    'Oceanside',
    'Saint Charles',
    'Woodstock',
    'Wesley Chapel',
    'Sugar Land',
    'Hialeah',
    'Cedar Rapids',
    'Fredericksburg',
    'Kingston',
    'Chula Vista',
    'Saginaw',
    'Brentwood',
    'McDonough',
    'Riverview',
    'Spartanburg',
    'Westfield',
    'Ontario',
    'New Haven',
    'Edmond',
    'Portsmouth',
    'Kent',
    'San Bernardino',
    'West Chester',
    'Chesapeake',
    'Noblesville',
    'Mission',
    'Edison',
    'Carmel',
    'Huntington Beach',
    'Elgin',
    'Stamford',
    'Antioch',
    'Leesburg',
    'West Bloomfield',
    'Bend',
    'Hartford',
    'Gaithersburg',
    'High Point',
    'Conway',
    'Bethlehem',
    'North Bergen',
    'Broken Arrow',
    'Danville',
    'Upper Marlboro',
    'Ames',
    'Scranton',
    'Chapel Hill',
    'Santa Clara',
    'Norwalk',
    'Loveland',
    'Winter Park',
    'Winchester',
    'Zionsville',
    'Vaughn',
    'Modesto',
    'Shreveport',
    'Killeen',
    'Saint Augustine',
    'Somerset',
    'North Las Vegas',
    'Princeton',
    'Youngstown',
    'Roseville',
    'Yonkers',
    'San Leandro',
    'The Villages',
    'Newport',
    'Bothell',
    'Norristown',
    'Indiana',
    'Ballwin',
    'San Marcos',
    'Jonesboro',
    'Poughkeepsie',
    'Toms River',
    'Saint Cloud',
    'Clifton',
    'Quincy',
    'Simpsonville',
    'Orange',
    'Elk Grove',
    'Livonia',
    'Longmont',
    'Sterling',
    'Topeka',
    'Roswell',
    'Hendersonville',
    'Ypsilanti',
    'Lynchburg',
    'Grand Prairie',
    'New Hampton',
    'Florissant',
    'Utica',
    'Morristown',
    'City of Saint Peters',
    'Macomb',
    'Richardson',
    'Hillsboro',
    'Ellicott City',
    'Traverse City',
    'Round Lake',
    'Palm Bay',
    'Fuquay-Varina',
    'Parker',
    'Douglasville',
    'Easton',
    'Chester',
    'Ashland',
    'Midlothian',
    'Independence',
    'Redmond',
    'Clayton',
    'Bay City',
    'Delray Beach',
    'Centreville',
    'Whittier',
    'Marysville',
    'Newburgh',
    'Oswego',
    'Pflugerville',
    'Palm Coast',
    'Hoboken',
    'Champaign',
    'Racine',
    'Santa Rosa',
    'Johnson City',
    'Norman',
    'Newport News',
    'Frederick',
    'Macon',
    'Waterford',
    'Union City',
    'Shelbyville',
    'Bowling Green',
    'Levittown',
    'Somerville',
    'Elizabethtown',
    'Eau Claire',
    "O'Fallon",
    'Buford',
    'Boulder',
    'Ft. Washington',
    'Mooresville',
    'Yuma',
    'Mt. Pleasant',
    'Mesquite',
    'Harrison',
    'Sumter',
    'Texarkana',
    'Pearland',
    'Missouri City',
    'Clermont',
    'Warwick',
    'Huntington',
    'Laredo',
    'Geneva',
    'Brownsville',
    'Palatine',
    'Ogden',
    'South Bend',
    'Newton',
    'Negley',
    'Herndon',
    'Bridgeport',
    'Naperville',
    'Holland',
    'Falls Church',
    'Fond du Lac',
    'Carlsbad',
    'Arvada',
    'Odessa',
    'Lithonia',
    'Conroe',
    'Humble',
    'Clinton Township',
    'State College',
    'Torrance',
    'Amarillo',
    'Ithaca',
    'Chesterfield',
    'Rancho Cucamonga',
    'Adrian',
    'Shawnee',
    'Southfield',
    'Flint',
    'Stony Brook',
    'Metairie',
    'Vienna',
    'Hanover',
    'Sunnyvale',
    'Santa Monica',
    'Citrus Heights',
    'Fair Oaks',
    'Saint Johns',
    'Matthews',
    'Grand Junction',
    'Tuscaloosa',
    'South Jordan',
    'Waldorf',
    'North Hollywood',
    'Union',
    'Kenner',
    'Orange Park',
    'Hillsborough',
    'Jamestown',
    'South Orange',
    'Royal Oak',
    'Maryville',
    'Homestead',
    'Santa Fe',
    'Hagerstown',
    'Plainville',
    'Kenosha',
    'Victorville',
    'Keller',
    'Beaumont',
    'Suwanee',
    'Billings',
    'Saratoga Springs',
    'Garden City',
    'Annapolis',
    'Greeley',
    'Missoula',
    'Soddy-Daisy',
    'Conyers',
    'Palmdale',
    'Hesperia',
    'Puyallup',
    'White Plains',
    'Fishers',
    'West Orange',
    'Manhattan',
    'Pomona',
    'Largo',
    'West Hartford',
    'Provo',
    'Marshfield',
    'Mount Pleasant',
    'Bowie',
    'Lakeville',
    'Bel Air',
    'Tyler',
    'Paterson',
    'Brockton',
    'Oxnard',
    'Camden',
    'New Bedford',
    'San Mateo',
    'League City',
    'Santa Barbara',
    'Stone Mountain',
    'Mount Holly',
    'Morrisville',
    'Seminole',
    'Greer',
    'Arlington Heights',
    'Batavia',
    'Lowell',
    'Pleasanton',
    'Chico',
    'Waukesha',
    'Yakima',
    'Reston',
    'Winter Garden',
    'Livingston',
    'El Cajon',
    'Kingsport',
    'Mechanicsburg',
    'Moreno Valley',
    'Urbana',
    'Boynton Beach',
    'Garner',
    'Muskegon',
    'West Des Moines',
    'Burbank',
    'Dalton',
    'Longview',
    'Otsego',
    'Nampa',
    'Palm Harbor',
    'Aberdeen',
    'Edwardsville',
    'Lynnwood',
    'McLean',
    'Waco',
    'Morgantown',
    'Gastonia',
    'McAllen',
    'Johnstown',
    'Lewisville',
    'Wappingers Falls',
    'Bridgewater',
    'Muncie',
    'Stafford',
    'West Jordan',
    'Kirkland',
    'Greenfield',
    'Newnan',
    'Cherry Hill',
    'Hammond',
    'Janesville',
    'Hickory',
    'Fort Mill',
    'Brookfield',
    'Rome',
    'Berkeley',
    "Lee's Summit",
    'Saint Joseph',
    'Kennewick',
    'Medina',
    'Cordova',
    'Cranston',
    'Berlin',
    'Towson',
    'Pueblo',
    'Burnsville',
    'Broomfield',
    'Cookeville',
    'Cerritos',
    'Stockbridge',
    'Surprise',
    'Zanesville',
    'Bozeman',
    'Brookline',
    'Simi Valley',
    'Hixson',
    'Sparta',
    'Lansdale',
    'Vero Beach',
    'La Grange',
    'Temecula',
    'Bloomfield',
    'Oak Park',
    'Bethesda',
    'Fullerton',
    'Warner Robins',
    'Evanston',
    'Cumberland',
    'Palmyra',
    'Wylie',
    'Elyria',
    'Owings Mills',
    'Jasper',
    'Cheyenne',
    'Bismarck',
    'Blue Springs',
    'Mountain View',
    'Thousand Oaks',
    'Hemet',
    'Spring Valley',
    'Garden Grove',
    'Iowa City',
    "Coeur d'Alene",
    'Liberty',
    'Clovis',
    'Clarkton',
    'Strongsville',
    'Williamsburg',
    'Sparks',
    'Butler',
    'Windsor',
    'New Braunfels',
    'Hoffman',
    'Newtown',
    'Apopka',
    'Logan',
    'Parkville',
    'Pottstown',
    'Mason',
    'East Orange',
    'Corvallis',
    'Oshkosh',
    'Loganville',
    'Andover',
    'Snellville',
    'New Baltimore',
    'Lockport',
    'Sioux City',
    'Annandale',
    'Sicklerville',
    'Waynesboro',
    'Van Nuys',
    'Hawthorne',
    'Malden',
    'Danbury',
    'Hackensack',
    'West Bend',
    'Secaucus',
    'Montclair',
    'Waxhaw',
    'Eden Prairie',
    'North Port',
    'Elizabeth',
    'Northville',
    'Redwood City',
    'Altoona',
    'La Crosse',
    'Pittsfield',
    'North Richland Hills',
    'San Ramon',
    'Ventura',
    'Malvern',
    'Costa Mesa',
    'Dothan',
    'Douglas',
    'Attleboro',
    'Slidell',
    'Suffolk',
    'Miami Beach',
    'Santa Cruz',
    'Orem',
    'Laurelton',
    'Hattiesburg',
    'Monticello',
    'Pharr',
    'Lodi',
    'Smithfield',
    'Binghamton',
    'Sewell',
    'Ridgewood',
    'West Valley City',
    'Taylor',
    'Hilo',
    'Compton',
    'Lewiston',
    'Goldsboro',
    'Freeport',
    'Venice',
    'Rocky Mount',
    'Waterloo',
    'Westwood',
    'Ephrata',
    'Sandy',
    'McHenry',
    'Kennesaw',
    'Lake Zurich',
    'Highland',
    'Westerville',
    'Fort Lee',
    'Valrico',
    'Davis',
    'Wellington',
    'Inglewood',
    'Palm Beach Gardens',
    'Rapid City',
    'Valparaiso',
    'Burke',
    'Belmont',
    'Panama City',
    'Frankfort',
    'Abilene',
    'Grand Island',
    'Lima',
    'Harlingen',
    'Sonora',
    'Huntersville',
    'Bloomfield Hills',
    'Westland',
    'Urbandale',
    'Flagstaff',
    'Murrieta',
    'Massillon',
    'Fort Smith',
    'Mentor',
    'Temple',
    'Lehigh Acres',
    'Fairport',
    'Lake Charles',
    'Wheaton',
    'Bryan',
    'Bell Gardens',
    'Hilliard',
    'Daytona Beach',
    'Mankato',
    'Wheeling',
    'Jupiter',
    'Redding',
    'Amherst',
    'Pawtucket',
    'Meriden',
    "Land O' Lakes",
    'Deltona',
    'Rio Rancho',
    'Stillwater',
    'Boone',
    'Layton',
    'Framingham',
    'Mililani Town',
    'Riverdale',
    'Winter Haven',
    'Bangor',
    'New Albany',
    'Sun Prairie',
    'Terre Haute',
    'Seymour',
    'Chicopee',
    'Bluffton',
    'Elkhart',
    'Fenton',
    'Waltham',
    'Hyde Park',
    'Mount Laurel',
    'Kearney',
    'Lynn',
    'Ankeny',
    'Newton Center',
    'East Lansing',
    'Wilson',
    'West Lafayette',
    'Titusville',
    'Maple Grove',
    'Ormond Beach',
    'Salinas',
    'Thomasville',
    'Great Neck',
    'Ooltewah',
    'Portage',
    'Clarksburg',
    'Deer Park',
    'La Porte',
    'Gig Harbor',
    'Weslaco',
    'Egg Harbor',
    'Las Cruces',
    'Hamburg',
    'Castro Valley',
    'Battle Creek',
    'Leander',
    'Camarillo',
    'Clifton Park',
    'New Rochelle',
    'Sheboygan',
    'Madison Heights',
    'Flower Mound',
    'Phoenixville',
    'Fairmont',
    'Marshall',
    'Woodland Hills',
    'Chaska',
    'Oviedo',
    'Mitchell',
    'Valley Stream',
    'Jefferson City',
    'Tracy',
    'Visalia',
    'Potomac',
    'Mechanicsville',
    'Wichita Falls',
    'Redondo Beach',
    'Hempstead',
    'Caldwell',
    'Grove City',
    'Smithtown',
    'Waxahachie',
    'Helena',
    'Wausau',
    'Palo Alto',
    'Nashua',
    'Bay Shore',
    'Fall River',
    'Fitchburg',
    'St. George',
    'Idaho Falls',
    'Lutherville-Timonium',
    'Freehold',
    'Pasco',
    'Federal Way',
    'North Canton',
    'Carlisle',
    'Downingtown',
    'Port Orange',
    'Lake Forest',
    'Euless',
    'Goose Creek',
    'Renton',
    'Great Falls',
    'McMinnville',
    'Petersburg',
    'Kannapolis',
    'Webster',
    'Acworth',
    'Vallejo',
    'Burnet',
    'Springdale',
    'New Berlin',
    'Magnolia',
    'Havre de Grace',
    'Mission Viejo',
    'Morganton',
    'Council Bluffs',
    'DeLand',
    'Wakefield',
    'Des Plaines',
    'Collingswood',
    'El Centro',
    'Schaumburg',
    'Deptford',
    'Kernersville',
    'Harrisonburg',
    'Glen Burnie',
    'Roseburg',
    'Teaneck',
    'New Bern',
    'Parkersburg',
    'De Pere',
    'Port Huron',
    'Fair Lawn',
    'Folsom',
    'Margate',
    'Lumberton',
    'Asheboro',
    'Grovetown',
    'Camp Hill',
    'Doylestown',
    'Oak Creek',
    'Powder Springs',
    'Moultrie',
    'Beaufort',
    'Findlay',
    'Statesville',
    'Niagara Falls',
    'Essex',
    'Neenah',
    'Benton',
    'San Luis Obispo',
    'Winter Springs',
    'Bellflower',
    'Owensboro',
    'Crystal Lake',
    'Barrington',
    'Niles',
    'Canonsburg',
    'Pittsburg',
    'Martinsville',
    'Marlton',
    'Indio',
    'Olney',
    'Blacksburg',
    'Cedar Park',
    'Miamisburg',
    'Gadsden',
    'Kokomo',
    'Goshen',
    'Weatherford',
    'Walnut Creek',
    'Valdosta',
    'Northampton',
    'Escondido',
    'Perkasie',
    'Reseda',
    'Chino Hills',
    'Manteca',
    'Joplin',
    'Crown Point',
    'Severn',
    'Rocklin',
    'Hopkins',
    'Lake Elsinore',
    'Irvington',
    'Rossville',
    'Yukon',
    'Gonzales',
    'Irwin',
    'Cabot',
    'Oak Harbor',
    'Rancho Cordova',
    'Farmingdale',
    'Kailua-Kona',
    'Edmonds',
    'Gulfport',
    'Joliet',
    'Bremerton',
    'Tustin',
    'Fairburn',
    'Old Bridge',
    'Linden',
    'Ambler',
    'Indian Trail',
    'Milpitas',
    'Lenexa',
    'Reynoldsburg',
    'El Dorado Hills',
    'Valencia',
    'Edinburg',
    'Abingdon',
    'Perris',
    'Menifee',
    'Boerne',
    'Basking Ridge',
    'Denham Springs',
    'Lombard',
    'Forney',
    'Castle Rock',
    'Chino',
    'Palm Desert',
    'Merced',
    'Lawrenceburg',
    'Elmhurst',
    'Eureka',
    'Goodyear',
    'Wallingford',
    'West Columbia',
    'Ronkonkoma',
    'Lanham',
    'Richland',
    'St. Cloud',
    'Mount Juliet',
    'Alameda',
    'Auburndale',
    'Havertown',
    'Hermitage',
    'Southampton',
    'Lutz',
    'Daly City',
    'Hicksville',
    'Jamaica Plain',
    'Taylors',
    'Elkridge',
    'Bolingbrook',
    'Port Charlotte',
    'Fitzgerald',
    'Pembroke',
    'Skokie',
    'Powell',
    'DeKalb',
    'Bentonville',
    'Carbondale',
    'Shelby',
    'Seguin',
    'Menomonee Falls',
    'Buffalo Grove',
    'Hastings',
    'Lehi',
    'Mount Airy',
    'Glen Ellyn',
    'Vineland',
    'Wyoming',
    'Downey',
    'Paris',
    'Starkville',
    'Coventry',
    'Cupertino',
    'Paducah',
    'Coatesville',
    'Glen Allen',
    'Wentzville',
    'Victoria',
    'Queen Creek',
    'La Puente',
    'Seneca',
    'Hot Springs',
    'Clarkston',
    'Claremont',
    'DeSoto',
    'Winder',
    'Latrobe',
    'Fort Walton Beach',
    'Waterbury',
    'New Brunswick',
    'Yorba Linda',
    'Lyndhurst',
    'Massapequa',
    'Westbury',
    'Batesville',
    'Kearny',
    'Port Orchard',
    'Cartersville',
    'Pinckney',
    'Orland Park',
    'Canyon Country',
    'Lenoir',
    'Orangeburg',
    'Huntington Station',
    'Clearfield',
    'Norwood',
    'Graysville',
    'South Windsor',
    'New Milford',
    'Sun City',
    'The Colony',
    'Catonsville',
    'Natick',
    'Connellsville',
    'Rockwall',
    'Monroeville',
    'Dundalk',
    'Itta Bena',
    'Grand Forks',
    'Marlborough',
    'Port Richey',
    'Warsaw',
    'Mableton',
    'Jefferson',
    'Elkton',
    'San Angelo',
    'Jeffersonville',
    'Nottingham',
    'Lincolnton',
    'McKeesport',
    'Gresham',
    'Alhambra',
    'Hamden',
    'Clementon',
    'Middleton',
    'Plainview',
    'London',
    'Uniontown',
    'Highland Park',
    'Chatsworth',
    'Rogers',
    'Chillicothe',
    'Passaic',
    'Cornelius',
    'Napa',
    'Waukegan',
    'Endicott',
    'Grand Blanc',
    'Toccoa',
    'Casper',
    'Tifton',
    'Moscow',
    'Aiken',
    'Yucaipa',
    'Riverton',
    'Coraopolis',
    'Prescott',
    'Pontiac',
    'Livermore',
    'Lawton',
    'Easley',
    'Hinesville',
    'Carmichael',
    'Dacula',
    'Sturgeon Bay',
    'Hilton Head Island',
    'Downers Grove',
    'Shrewsbury',
    'Sammamish',
    'Stuart',
    'Little Elm',
    'Redford',
    'Brewster',
    'Peachtree City',
    'Altamonte Springs',
    'Beverly',
    'Fort Mitchell',
    'Alachua',
    'Menlo Park',
    'Upland',
    'Gurnee',
    'Queensbury',
    'Williamsport',
    'Lewisburg',
    'West Covina',
    'Carson',
    'Woonsocket',
    'Mill Valley',
    'Moorhead',
    'Waynesville',
    'Griffin',
    'Beverly Hills',
    'Vista',
    'Oak Ridge',
    'Carthage',
    'Commerce',
    'West Babylon',
    'Warrenton',
    'Walled Lake',
    'Ada',
    'Collierville',
    'Lorain',
    'Belton',
    'Stratford',
    'Bossier City',
    'Graham',
    'Wixom',
    'Davison',
    'East Stroudsburg',
    'Carson City',
    'Wethersfield',
    'Ardmore',
    'Blackwood',
    'Leland',
    'New London',
    'Lindenhurst',
    'Williamstown',
    'Grafton',
    'Whiting',
    'Russellville',
    'Placentia',
    'Liverpool',
    'Cuyahoga Falls',
    'Northport',
    'Millsboro',
    'Perrysburg',
    'Pocatello',
    'Lilburn',
    'Statesboro',
    'Chagrin Falls',
    'Meadville',
    'Brookings',
    'San Rafael',
    'Nicholasville',
    'Greenwich',
    'Enterprise',
    'Centerville',
    'Bonney Lake',
    'Maplewood',
    'Vacaville',
    'Clemson',
    'Hutchinson',
    'Pacoima',
    'Short Hills',
    'Kalispell',
    'Norcross',
    'Peabody',
    'Grants Pass',
    'Cassville',
    'Osseo',
    'Staunton',
    'Flushing',
    'Matawan',
    'Southport',
    'Newport Beach',
    'Huntington Woods',
    'Elk Grove Village',
    'Avondale',
    'Owosso',
    'Pullman',
    'Bullhead City',
    'Sandusky',
    'Walla Walla',
    'Darien',
    'Selma',
    'Bethel Park',
    'Pinellas Park',
    'Derby',
    'Saint Marys',
    'Lake City',
    'Town and Country',
    'Woburn',
    'Buckeye',
    'Normal',
    'Ft. Pierce',
    'Eagle',
    'San Clemente',
    'Coos Bay',
    'Burleson',
    'Bensalem',
    'West New York',
    'Sevierville',
    'Bellmore',
    'Severna Park',
    'Chevy Chase',
    'Bayonne',
    'Cortland',
    'Berea',
    'Golden',
    'Fountain Valley',
    'Elkhorn',
    'Crofton',
    'Spring Lake',
    'Granger',
    'Chambersburg',
    'Coppell',
    'Taunton',
    'Gloucester',
    'Baytown',
    'Laughlin',
    'Foley',
    'Delaware',
    'Scituate',
    'New Britain',
    'Grapevine',
    'Media',
    'Wasilla',
    'Asbury Park',
    'Fairhope',
    'Rolling Meadows',
    'Rockledge',
    'Encinitas',
    'Fulton',
    'West Newton',
    'Santa Maria',
    'Ozark',
    'Apollo',
    'Onalaska',
    'Hingham',
    'Oak Lawn',
    'Marquette',
    'Charlestown',
    'Odenton',
    'Wenatchee',
    'Glendora',
    'Huntley',
    'New Hyde Park',
    'Langhorne',
    'Ruskin',
    'Turlock',
    'Marrero',
    'Azusa',
    'Gardner',
    'Oconomowoc',
    'Paramus',
    'Merrick',
    'Antelope',
    'Bergenfield',
    'Anoka',
    'Rockingham',
    'Peachtree Corners',
    'Biloxi',
    'Delmar',
    'Cedar Falls',
    'Berwyn',
    'Crestview',
    'Irmo',
    'Acton',
    'Englishtown',
    'Beachwood',
    'Bear',
    'Papillion',
    'Boiling Springs',
    'San Pedro',
    'Berkeley Springs',
    'Covina',
    'Spencer',
    'Lititz',
    'Northbrook',
    'Pelham',
    'Tualatin',
    'New Kensington',
    'Painesville',
    'Crossville',
    'Waterville',
    'Pineville',
    'Kyle',
    'Muskego',
    'Scarsdale',
    'Evans',
    'Caledonia',
    'Trumbull',
    'Leominster',
    'Arnold',
    'North Little Rock',
    'Sykesville',
    'Elk River',
    'Murrells Inlet',
    'Woodland',
    'Lansdowne',
    'East Hartford',
    'Hightstown',
    'Canoga Park',
    'El Monte',
    'Pikesville',
    'Laguna Niguel',
    'Collinsville',
    'Bessemer',
    'Cedar Hill',
    'Herriman',
    'Elmont',
    'Collegeville',
    'Flemington',
    'Perry',
    'Grand Haven',
    'Prairieville',
    'Waipahu',
    'Plattsburgh',
    'Mequon',
    'Yuba City',
    'Cibolo',
    'Windermere',
    'Shepherdsville',
    'Colchester',
    'Plant City',
    'Bonita Springs',
    'Cicero',
    'Methuen',
    'Shepherd',
    'Latham',
    'Red Bank',
    'Burlingame',
    'Libertyville',
    'Parrish',
    'Grandville',
    'Gettysburg',
    'North Adams',
    'North Tonawanda',
    'Hyannis',
    'Ponte Vedra',
    'Verona',
    'Inverness',
    'Sidney',
    'Aldie',
    'Bartlett',
    'Alton',
    'Aubrey',
    'Hobbs',
    'Northridge',
    'Torrington',
    'Vestal',
    'Tomball',
    'Mountain Home',
    'Deerfield',
    'Olive Branch',
    'Mandeville',
    'Saint Clair Shores',
    'Sherwood',
    'Pleasantville',
    'Apple Valley',
    'Friendswood',
    'Grosse Pointe',
    'New City',
    'Prosper',
    'Wilkes-Barre',
    'Sherman',
    'Allen Park',
    'Merritt Island',
    'North Brunswick',
    'Phenix City',
    'Richmond Hill',
    'Wellesley Hills',
    'Forsyth',
    'Twinsburg',
    'Parsippany',
    'Arcadia',
    'Tucker',
    'Fairborn',
    'District Heights',
    'New Smyrna Beach',
    'Elmira',
    'Hampstead',
    'Martinsburg',
    'Bath',
    'Monrovia',
    'Weaverville',
    'Oneonta',
    'Quakertown',
    'Tonawanda',
    'Sharon',
    'East Brunswick',
    'Walpole',
    'Piedmont',
    'American Fork',
    'Harker Heights',
    'Sylvania',
    'Vicksburg',
    'Los Altos',
    'Los Gatos',
    'Homosassa',
    'Yorktown Heights',
    'Montrose',
    'Carpentersville',
    'Rensselaer',
    'Allendale',
    'Fleming Island',
    'Palmetto',
    'Tinley Park',
    'Edgewater',
    'Summerfield',
    'South Lyon',
    'Boardman',
    'Hoffman Estates',
    'Mukwonago',
    'Holly Springs',
    'Holyoke',
    'Reidsville',
    'Hackettstown',
    'Donnelsville',
    'Moncks Corner',
    'Patchogue',
    'Rahway',
    'West Roxbury',
    'Bucyrus',
    'Shirley',
    'Petaluma',
    'Rosemead',
    'Lillington',
    'Kingwood',
    'Bolivar',
    'Cranberry Township',
    'South San Francisco',
    'Sebring',
    'Cranford',
    'Little River',
    'San Pablo',
    'Lisle',
    'Calabash',
    'Bloomingdale',
    'Shakopee',
    'Chatham',
    'Pleasant Hill',
    'Twin Falls',
    'North Charleston',
    'Cottage Grove',
    'Klamath Falls',
    'Celina',
    'Ridgeland',
    'Opelika',
    'Brownsburg',
    'Michigan City',
    'Shallotte',
    'Campbell',
    'Redlands',
    'Ossining',
    'Greeneville',
    'Shelton',
    "'Ewa Beach",
    'Rialto',
    'Halethorpe',
    'Haines City',
    'Lufkin',
    'Evergreen Park',
    'North Olmsted',
    'Lincoln Park',
    'Gallatin',
    'Monument',
    'Cementon',
    'Johnston',
    'Kingman',
    'Galveston',
    'Lake Villa',
    'Nutley',
    'Randolph',
    'Alliance',
    'Port Washington',
    'Lewis Center',
    'Stoughton',
    'Brevard',
    'Sebastian',
    'Howell',
    'Tarpon Springs',
    'Leawood',
    'Lake Havasu City',
    'Montebello',
    'Salina',
    'Lake Oswego',
    'Billerica',
    'Dearborn Heights',
    'North Augusta',
    'Punta Gorda',
    'Gray',
    'Mays Landing',
    'North Wales',
    'Northfield',
    'Yorktown',
    'Aliso Viejo',
    'Addison',
    'West Warwick',
    'Gary',
    'San Tan Valley',
    'Winona',
    'Rancho Palos Verdes',
    'Southlake',
    'Leavenworth',
    'Southington',
    'Thibodaux',
    'Poway',
    'Floral Park',
    'King of Prussia',
    'Cape Girardeau',
    'Wooster',
    'Ca\u00f1on City',
    'Baraboo',
    'Laramie',
    'Knightdale',
    'Issaquah',
    'Roselle',
    'Kennett Square',
    'Branson',
    'Pell City',
    'Wisconsin Rapids',
    'Watsonville',
    'Forest Park',
    'Little Falls',
    'Santa Clarita',
    'Kittanning',
    'Rayland',
    'Stroudsburg',
    'Peru',
    'Dundee',
    'Moorestown',
    'La Mirada',
    'Louisburg',
    'Drayton',
    'Atwater',
    'Long Branch',
    'Sheridan',
    'Manahawkin',
    'Ocean Springs',
    'Amsterdam',
    'Albemarle',
    'Mundelein',
    'Groton',
    'Chantilly',
    'Gretna',
    'Buena Park',
    'Storrs',
    'Gibsonia',
    'Pulaski',
    'La Jolla',
    'Hartwell',
    'Bourbonnais',
    'Waverly',
    'Lake Orion',
    'Middleburg',
    'La Mesa',
    'Deerfield Beach',
    'Westbrook',
    'Hopkinsville',
    'Syosset',
    'Blairsville',
    'East Northport',
    'Belleview',
    'Copperas Cove',
    'Hummelstown',
    'Glen Cove',
    'Brea',
    'Beltsville',
    'Key West',
    'Panama City Beach',
    'Commack',
    'Morrow',
    'Southaven',
    'Minot',
    'Ottawa',
    'Tewksbury',
    'Columbia City',
    'Amelia',
    'Sylmar',
    'Glenview',
    'Kingsland',
    'Saint Albans',
    'Westlake',
    'Naugatuck',
    'Chelmsford',
    'Gardena',
    'Warminster',
    'West Haven',
    'Rockville Centre',
    'North Vernon',
    'Beaver Dam',
    'Brooksville',
    'Diamond Bar',
    'Red Oak',
    'Morgan Hill',
    'Flowery Branch',
    'Commerce City',
    'Maywood',
    'Navarre',
    'Phillipsburg',
    'Leesville',
    'La Habra',
    'Pooler',
    'West Monroe',
    'Daphne',
    'Absecon',
    'Greenbrier',
    'Sunbury',
    'Granbury',
    'Pekin',
    'Waunakee',
    'Dedham',
    'South Burlington',
    'Maricopa',
    'Texas City',
    'La Plata',
    'Merchantville',
    'Santee',
    'North Fort Myers',
    'San Dimas',
    'Gaffney',
    'Rowlett',
    'Wildwood',
    'Park City',
    'Monterey Park',
    'Neptune City',
    'Loris',
    'Culver City',
    'El Dorado',
    'Onawa',
    'Monterey',
    'Danvers',
    'Bennington',
    'Glenmont',
    'Corning',
    'Rutland',
    'Stow',
    'Madisonville',
    'Moses Lake',
    'Haverhill',
    'Homer Glen',
    'Anniston',
    'Clemmons',
    'Woodway',
    'Eatontown',
    'Hudsonville',
    'Ellensburg',
    'Roscoe',
    'Dickinson',
    'Trussville',
    'Pikeville',
    'Palatka',
    'Hays',
    'Calhoun',
    'Casa Grande',
    'Imperial',
    'Cathedral City',
    'Rexburg',
    'Weston',
    'Holden',
    'San Carlos',
    'Benton Harbor',
    'Wadsworth',
    'Sierra Vista',
    'Pahrump',
    'Madera',
    'Argyle',
    'Easthampton',
    'Platteville',
    'Stevens Point',
    'Oakdale',
    'Cliffside Park',
    'Park Ridge',
    'Forest',
    'Fairview',
    'Beckley',
    'Brainerd',
    'Sherman Oaks',
    'Elizabeth City',
    'University Park',
    'Abbeville',
    'Bastrop',
    'Summit',
    'Gilroy',
    'Morehead City',
    'Rincon',
    'Kaneohe',
    'East Falmouth',
    'Youngsville',
    'Fredonia',
    'Cullman',
    'Chapin',
    'College Park',
    'Kihei',
    'Fernandina Beach',
    'Randolph Township',
    'Forest City',
    'Satellite Beach',
    'Eagle Mountain',
    'Mahwah',
    'Ferndale',
    'Dracut',
    'Duncan',
    'Branford',
    'Carnegie',
    'Mishawaka',
    'Suitland',
    'Hinsdale',
    'Bettendorf',
    'Dyersburg',
    'Warrington',
    'Voorhees Township',
    'Southbridge',
    'Bemidji',
    'Owasso',
    'Manlius',
    'Manitowoc',
    'Temple Hills',
    'Durango',
    'Ringgold',
    'Prairie Village',
    'Houma',
    'Cocoa',
    'Swansea',
    'Gulf Breeze',
    'Manhattan Beach',
    'Newberg',
    'Lenoir City',
    'Xenia',
    'Randallstown',
    'Solon',
    'Saratoga',
    'Edgewood',
    'Jenison',
    'Millington',
    'Canandaigua',
    'Beaver Falls',
    'Revere',
    'Galion',
    'Seville',
    'Rohnert Park',
    'Lithia',
    'Atlantic City',
    'Schertz',
    'Candler',
    'Belmar',
    'Swedesboro',
    'Colton',
    'Roslindale',
    'Perth Amboy',
    'Orange City',
    'Millbury',
    'Hartland',
    'Goleta',
    'Pacifica',
    'Drexel Hill',
    'Haddonfield',
    'Chelsea',
    'Hanover Park',
    'Mount Prospect',
    'High Springs',
    'Kinston',
    'Westport',
    'Ballston Spa',
    'Pottsville',
    'Derry',
    'East Greenwich',
    'Supply',
    'New Iberia',
    'Jeannette',
    'Needham',
    'Johns Island',
    'Honeoye Falls',
    'Blountville',
    'Kailua',
    'Bardstown',
    'Pataskala',
    'Woodridge',
    'Springville',
    'Hollister',
    'Willingboro',
    'Rice Lake',
    'Tiffin',
    'Dunedin',
    'Lacey',
    'Big Lake',
    'Winnetka',
    'Baldwin Park',
    'Warrensburg',
    'Wailuku',
    'Versailles',
    'Moline',
    'South Pasadena',
    'Bayville',
    'Taylorville',
    'Opelousas',
    'Middleboro',
    'Calabasas',
    'Port Chester',
    'Hanford',
    'Capitol Heights',
    'Cleburne',
    'Waukee',
    'Inkster',
    'Newbury Park',
    'Duncanville',
    'Harpswell',
    'Merrillville',
    'Inman',
    'Milledgeville',
    'Jonesborough',
    'Temperance',
    'Dahlonega',
    'Delano',
    'Baldwin',
    'South Gate',
    'Pella',
    'Bad Axe',
    'Crawfordsville',
    'New Philadelphia',
    'Coram',
    'Oregon City',
    'Keene',
    'Granite City',
    'Weehawken',
    'East Hampton',
    'Kapolei',
    'Spring Grove',
    'Tupelo',
    'Victor',
    'Corinth',
    'North Liberty',
    'Port Arthur',
    'Two Rivers',
    'Chesterton',
    'Mahopac',
    'Lehighton',
    'Barnegat',
    'Springboro',
    'Flat Rock',
    'Potsdam',
    'Hazleton',
    'Sedalia',
    'Selden',
    'Tower',
    'Exeter',
    'Granada Hills',
    'Spanish Fork',
    'Sycamore',
    'Bartlesville',
    'Baldwinsville',
    'Avon Lake',
    'Stanford',
    'Elmwood Park',
    'Enfield',
    'Rocky River',
    'Havelock',
    'Seaford',
    'Girard',
    'Blythewood',
    'Okemos',
    'Mount Joy',
    'Rockaway',
    'Alamogordo',
    'Haledon',
    'South Plainfield',
    'Rosedale',
    'Dillon',
    'Closter',
    'Campbellsville',
    'Pittsboro',
    'Algonquin',
    'San Benito',
    'Rancho Santa Margarita',
    'East Setauket',
    'Superior',
    'Lake Ariel',
    'Humboldt',
    'Mebane',
    'Pinehurst',
    'San Bruno',
    'Safety Harbor',
    'Green Valley',
    'Carol Stream',
    'Rhinelander',
    'Lewes',
    'Milan',
    'Greenbelt',
    'Porterville',
    'Hillsdale',
    'Sonoma',
    '\u2018Aiea',
    'Poplar Grove',
    'Ludlow',
    'Lake Stevens',
    'Falmouth',
    'Fort Bragg',
    'Murrysville',
    'Smithville',
    'Millville',
    'Prior Lake',
    'Howell Township',
    'Hopewell Junction',
    'La Marque',
    'Eustis',
    'Auburn Hills',
    'Lake Mary',
    'Maple Valley',
    'Dumfries',
    'Mattoon',
    'Hewitt',
    'Mocksville',
    'Cleveland Heights',
    'Niceville',
    'Novato',
    'Royse City',
    'Sturgis',
    'Winfield',
    'Owatonna',
    'Wells',
    'Gwynn Oak',
    'Westerly',
    'Millersville',
    'Williamston',
    'Bellefontaine',
    'Stanwood',
    'Huntingtown',
    'Olean',
    'Pearl City',
    'Dunkirk',
    'Fairbanks',
    'Hammonton',
    'Millbrook',
    'East Providence',
    'Durant',
    'Culpeper',
    'Draper',
    'Apache Junction',
    'Gillette',
    'Prescott Valley',
    'Hephzibah',
    'Barberton',
    'East Wenatchee',
    'Mt. Dora',
    'New Cumberland',
    'Petoskey',
    'Clover',
    'Dunlap',
    'Newington',
    'California',
    'Defiance',
    'Grove',
    'Walterboro',
    'Martin',
    'Hernando',
    'Glasgow',
    'Grass Valley',
    'South Lake Tahoe',
    'Riverhead',
    'Harvey',
    'Claremore',
    'North Ridgeville',
    'Mountain Top',
    'Lapeer',
    'Beloit',
    'Lexington Park',
    'Ocean Isle Beach',
    'Blacklick',
    'Paso Robles',
    'Frostburg',
    'Westborough',
    'Laurinburg',
    'Manvel',
    'Snohomish',
    'Byron',
    'Rock Springs',
    'Galloway',
    'Poulsbo',
    'Bridgeton',
    'Alfred',
    'Stevensville',
    'Sylva',
    'Weirton',
    'Pepperell',
    'Hacienda Heights',
    'Harleysville',
    'Iron Mountain',
    'Oneida',
    'Middle River',
    'Zion',
    'Rocky Hill',
    'Charles Town',
    'Westford',
    'Yankton',
    'Wantagh',
    'Sayville',
    'Lorton',
    'Melrose',
    'Stanton',
    'Raeford',
    'Saddle River',
    'Dickson',
    'Tobyhanna',
    'Pickerington',
    'Scarborough',
    'Oakley',
    'Schererville',
    'Lompoc',
    'Sudbury',
    'Palm Springs',
    'Ponte Vedra Beach',
    'Hurricane',
    'Villa Park',
    'Hallandale',
    'Hartsville',
    'Alvin',
    'West Chicago',
    'Tulare',
    'Alma',
    'Ocean City',
    'Scotch Plains',
    'Itasca',
    'Coldwater',
    'Mercer Island',
    'Zephyrhills',
    'Cedar City',
    'Oroville',
    'Green Hill',
    'Glenside',
    'Jenks',
    'Big Rapids',
    'Zebulon',
    'Hopkinton',
    'Raymore',
    'Cortlandt Manor',
    'Belfast',
    'Clarksdale',
    'Juneau',
    'Nederland',
    'Atascadero',
    'Willowbrook',
    'Loogootee',
    'Cheshire',
    'Rock Island',
    'Garfield',
    'McKees Rocks',
    'Nacogdoches',
    'Panorama City',
    'West Milford',
    'Emmaus',
    'Tallassee',
    'Sussex',
    'New Ulm',
    'Lake Saint Louis',
    'Mamaroneck',
    'Roanoke Rapids',
    'Brockport',
    'Windsor Locks',
    'Kankakee',
    'Guilford',
    'Huntingdon Valley',
    'Newberry',
    'Chicago Heights',
    'Nanuet',
    'Chardon',
    'Mason City',
    'Zachary',
    'Mineola',
    'New Lenox',
    'Martinez',
    'Olmsted Falls',
    'North Kingstown',
    'Ville Platte',
    'Tullahoma',
    'North Wilkesboro',
    'Sayre',
    'Sulphur',
    'Eagle River',
    'Telford',
    'Alden',
    'Calumet City',
    'Wyckoff',
    'Liberty Hill',
    'Pico Rivera',
    'Munster',
    'Fort Dodge',
    'Buda',
    'Douglassville',
    'Muskogee',
    'Laplace',
    'Ruston',
    'Ripley',
    'Okatie',
    'Nixa',
    'Central Islip',
    'Festus',
    'Rockport',
    'Opa-locka',
    'Centereach',
    'West Islip',
    'Ramsey',
    'Destin',
    'Pittsford',
    'Cape May',
    'Sikeston',
    'Princeton Junction',
    'Williston',
    'Galesburg',
    'Chalfont',
    'Braintree',
    'Indianola',
    'Breckenridge',
    'Ridgefield',
    'Huntingdon',
    'Pleasant Grove',
    'Circleville',
    'Abington',
    'Hood River',
    'Sun City West',
    'New Windsor',
    'Reisterstown',
    'Travelers Rest',
    'Connersville',
    'Richfield',
    'Hornell',
    'Brazil',
    'Ellsworth',
    'Corbin',
    'South Haven',
    'Emporia',
    'Wynnewood',
    'Belle Vernon',
    'Eden',
    'Yulee',
    'Rolla',
    'Ocoee',
    'Palestine',
    'Wendell',
    'Roy',
    'Hebron',
    'Rutherford',
    'Bronxville',
    'Biddeford',
    'Kinwood',
    'New Market',
    'Agoura Hills',
    'Exton',
    'Guyton',
    'Spanaway',
    'New Providence',
    'Newtown Square',
    'Sandwich',
    'Port Jefferson Station',
    'Sedona',
    'Denison',
    'Glenwood',
    'Rye',
    'Poplar Bluff',
    'Morris',
    'Three Rivers',
    'Semmes',
    'Ponchatoula',
    'Woodinville',
    'Marina',
    'Los Alamitos',
    'mask',
    null,
  ],
  deviceType: [
    'others',
    'Smartphone',
    'Personal computer',
    'Smart TV',
    'Tablet',
    'Game console',
    'mask',
    null,
  ],
  day_of_week: [
    'others',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Monday',
    'Sunday',
    'mask',
    null,
  ],
  hour_of_day: [
    'others',
    '1',
    '0',
    '2',
    '20',
    '19',
    '18',
    '21',
    '17',
    '23',
    '16',
    '22',
    '15',
    '3',
    '14',
    '13',
    '4',
    '5',
    '12',
    '6',
    '11',
    '7',
    '10',
    '8',
    '9',
    'mask',
    null,
  ],
  category_text: [
    'others',
    '/arts_&_entertainment/tv_&_video/online_video',
    '/sports/team_sports/american_football',
    '/online_communities/online_goodies/social_network_apps_&_add-ons',
    '/people_&_society/family_&_relationships/family',
    '/arts_&_entertainment/comics_&_animation/anime_&_manga',
    '/internet_&_telecom/search_engines/people_search',
    '/games/computer_&_video_games/sports_games',
    '/computers_&_electronics/electronics_&_electrical/data_sheets_&_electronics_reference',
    '/sports/team_sports/basketball',
    '/computers_&_electronics/software/operating_systems',
    '/arts_&_entertainment/tv_&_video/tv_guides_&_reference',
    '/people_&_society/family_&_relationships/friendship',
    '/food_&_drink/food/meat_&_seafood',
    '/law_&_government/legal/labor_&_employment_law',
    '/shopping/consumer_resources/coupons_&_discount_offers',
    '/law_&_government/military/army',
    '/jobs_&_education/education/special_education',
    '/finance/credit_&_lending/loans',
    '/sports/combat_sports/martial_arts',
    '/business_&_industrial/business_operations/business_plans_&_presentations',
    '/business_&_industrial/business_services/office_services',
    '/jobs_&_education/education/colleges_&_universities',
    '/autos_&_vehicles/vehicle_shopping/fuel_economy_&_gas_prices',
    '/pets_&_animals/pets/dogs',
    '/food_&_drink/food_&_grocery_retailers/butchers',
    '/health/medical_facilities_&_services/hospitals_&_treatment_centers',
    '/finance/credit_&_lending/credit_cards',
    '/shopping/gifts_&_special_event_items/gifts',
    '/arts_&_entertainment/comics_&_animation/cartoons',
    '/food_&_drink/cooking_&_recipes/desserts',
    '/news/business_news/financial_markets',
    '/finance/accounting_&_auditing/tax_preparation_&_planning',
    '/law_&_government/public_safety/law_enforcement',
    '/people_&_society/social_issues_&_advocacy/privacy_issues',
    '/sports/team_sports/soccer',
    '/arts_&_entertainment/movies/family_films',
    '/arts_&_entertainment/movies/science_fiction_&_fantasy_films',
    '/beauty_&_fitness/face_&_body_care/unwanted_body_&_facial_hair_removal',
    '/beauty_&_fitness/face_&_body_care/make-up_&_cosmetics',
    '/law_&_government/government/government_contracting_&_procurement',
    '/jobs_&_education/education/teaching_&_classroom_resources',
    '/online_communities/online_goodies/skins_themes_&_wallpapers',
    '/internet_&_telecom/mobile_&_wireless/mobile_phones',
    '/shopping/consumer_resources/product_reviews_&_price_comparisons',
    '/business_&_industrial/advertising_&_marketing/sales',
    '/law_&_government/legal/family_law',
    '/food_&_drink/food/breakfast_foods',
    '/business_&_industrial/advertising_&_marketing/brand_management',
    '/law_&_government/legal/business_&_corporate_law',
    '/shopping/apparel/athletic_apparel',
    '/food_&_drink/cooking_&_recipes/soups_&_stews',
    '/arts_&_entertainment/music_&_audio/world_music',
    '/computers_&_electronics/computer_security/network_security',
    '/sports/team_sports/hockey',
    '/law_&_government/legal/product_liability',
    '/food_&_drink/cooking_&_recipes/culinary_training',
    '/arts_&_entertainment/movies/horror_films',
    '/sports/combat_sports/wrestling',
    '/business_&_industrial/energy_&_utilities/electricity',
    '/science/earth_sciences/atmospheric_science',
    '/travel/air_travel/airport_parking_&_transportation',
    '/finance/insurance/home_insurance',
    '/finance/banking/atms_&_branch_locations',
    '/internet_&_telecom/email_&_messaging/voice_&_video_chat',
    '/shopping/consumer_resources/customer_services',
    '/news/politics/campaigns_&_elections',
    '/law_&_government/military/navy',
    '/business_&_industrial/business_services/office_supplies',
    '/jobs_&_education/education/alumni_&_reunions',
    '/beauty_&_fitness/spas_&_beauty_services/massage_therapy',
    '/home_&_garden/home_furnishings/sofas_&_chairs',
    '/jobs_&_education/education/homeschooling',
    '/sports/individual_sports/golf',
    '/games/computer_&_video_games/fighting_games',
    '/finance/credit_&_lending/debt_management',
    '/sports/sporting_goods/baseball_equipment',
    '/business_&_industrial/aerospace_&_defense/defense_industry',
    '/law_&_government/legal/intellectual_property',
    '/arts_&_entertainment/tv_&_video/tv_networks_&_stations',
    '/finance/insurance/health_insurance',
    '/health/alternative_&_natural_medicine/cleansing_&_detoxification',
    '/health/nutrition/special_&_restricted_diets',
    '/hobbies_&_leisure/special_occasions/holidays_&_seasonal_events',
    '/shopping/toys/action_figures',
    '/business_&_industrial/agriculture_&_forestry/crops_&_seed',
    '/autos_&_vehicles/hybrid_&_alternative_vehicles/electric_&_plug-in_vehicles',
    '/arts_&_entertainment/tv_&_video/tv_commercials',
    '/food_&_drink/restaurants/pizzerias',
    '/arts_&_entertainment/movies/dvd_&_video_shopping',
    '/food_&_drink/food/cooking_fats_&_oils',
    '/finance/banking/savings_accounts',
    '/shopping/apparel/outerwear',
    '/arts_&_entertainment/music_&_audio/pop_music',
    '/internet_&_telecom/email_&_messaging/spam_&_email_filtering',
    '/health/medical_facilities_&_services/medical_procedures',
    '/shopping/apparel/footwear',
    '/hobbies_&_leisure/water_activities/boating',
    '/computers_&_electronics/software/business_&_productivity_software',
    '/law_&_government/military/air_force',
    '/law_&_government/legal/accident_&_personal_injury_law',
    '/sports/combat_sports/boxing',
    '/sports/sporting_goods/equestrian_equipment_&_tack',
    '/sports/sporting_goods/american_football_equipment',
    '/food_&_drink/food/candy_&_sweets',
    '/reference/geographic_reference/maps',
    '/food_&_drink/beverages/coffee_&_tea',
    '/finance/investing/commodities_&_futures_trading',
    '/food_&_drink/restaurants/dining_guides',
    '/beauty_&_fitness/face_&_body_care/perfumes_&_fragrances',
    '/arts_&_entertainment/movies/bollywood_&_south_asian_film',
    '/autos_&_vehicles/vehicle_brands/chevrolet',
    '/autos_&_vehicles/vehicle_brands/ford',
    '/hobbies_&_leisure/crafts/fiber_&_textile_arts',
    '/people_&_society/family_&_relationships/marriage',
    '/autos_&_vehicles/trucks_&_suvs/trucks',
    '/autos_&_vehicles/vehicle_brands/ferrari',
    '/people_&_society/social_sciences/psychology',
    "/shopping/apparel/women's_clothing",
    '/pets_&_animals/pets/reptiles_&_amphibians',
    '/games/computer_&_video_games/casual_games',
    '/finance/investing/currencies_&_foreign_exchange',
    '/food_&_drink/food/grains_&_pasta',
    '/computers_&_electronics/consumer_electronics/game_systems_&_consoles',
    '/jobs_&_education/jobs/job_listings',
    '/health/medical_facilities_&_services/physical_therapy',
    '/arts_&_entertainment/events_&_listings/concerts_&_music_festivals',
    '/computers_&_electronics/software/educational_software',
    '/sports/team_sports/baseball',
    '/reference/general_reference/calculators_&_reference_tools',
    '/sports/team_sports/cricket',
    '/finance/banking/debit_&_checking_services',
    '/people_&_society/social_sciences/archaeology',
    '/food_&_drink/cooking_&_recipes/bbq_&_grilling',
    '/health/nutrition/vitamins_&_supplements',
    '/law_&_government/public_safety/crime_&_justice',
    '/shopping/apparel/casual_apparel',
    '/online_communities/photo_&_video_sharing/video_sharing',
    '/shopping/apparel/headwear',
    '/business_&_industrial/business_operations/management',
    '/computers_&_electronics/software/device_drivers',
    '/health/health_conditions/cold_&_flu',
    '/computers_&_electronics/software/multimedia_software',
    '/people_&_society/family_&_relationships/romance',
    '/sports/team_sports/volleyball',
    '/computers_&_electronics/programming/scripting_languages',
    '/shopping/toys/building_toys',
    '/science/earth_sciences/paleontology',
    '/arts_&_entertainment/music_&_audio/radio',
    '/games/family-oriented_games_&_activities/dress-up_&_fashion_games',
    '/sports/motor_sports/auto_racing',
    '/health/public_health/health_policy',
    '/people_&_society/social_issues_&_advocacy/drug_laws_&_policy',
    '/business_&_industrial/agriculture_&_forestry/farms_&_ranches',
    '/business_&_industrial/energy_&_utilities/renewable_&_alternative_energy',
    '/beauty_&_fitness/face_&_body_care/skin_&_nail_care',
    '/people_&_society/social_issues_&_advocacy/charity_&_philanthropy',
    '/law_&_government/government/embassies_&_consulates',
    '/shopping/apparel/formal_wear',
    '/jobs_&_education/education/early_childhood_education',
    '/internet_&_telecom/mobile_&_wireless/mobile_&_wireless_accessories',
    '/food_&_drink/food/organic_&_natural_foods',
    '/arts_&_entertainment/movies/movie_memorabilia',
    '/law_&_government/military/veterans',
    '/arts_&_entertainment/music_&_audio/religious_music',
    '/arts_&_entertainment/movies/action_&_adventure_films',
    '/business_&_industrial/transportation_&_logistics/aviation',
    '/shopping/gifts_&_special_event_items/party_&_holiday_supplies',
    '/business_&_industrial/business_services/knowledge_management',
    '/pets_&_animals/animal_products_&_services/pet_food_&_supplies',
    '/science/computer_science/machine_learning_&_artificial_intelligence',
    '/reference/general_reference/forms_guides_&_templates',
    '/games/computer_&_video_games/driving_&_racing_games',
    '/arts_&_entertainment/movies/animated_films',
    '/beauty_&_fitness/face_&_body_care/hygiene_&_toiletries',
    '/computers_&_electronics/programming/c_&_c++',
    '/pets_&_animals/animal_products_&_services/animal_welfare',
    '/food_&_drink/cooking_&_recipes/cuisines',
    '/law_&_government/military/marines',
    '/business_&_industrial/advertising_&_marketing/promotional_items_&_corporate_gifts',
    '/reference/language_resources/foreign_language_resources',
    '/jobs_&_education/education/academic_conferences_&_publications',
    '/food_&_drink/restaurants/fast_food',
    '/travel/specialty_travel/vineyards_&_wine_tourism',
    '/sports/individual_sports/bowling',
    '/law_&_government/government/visa_&_immigration',
    '/health/alternative_&_natural_medicine/acupuncture_&_chinese_medicine',
    '/computers_&_electronics/software/internet_software',
    '/arts_&_entertainment/visual_art_&_design/art_&_craft_supplies',
    '/autos_&_vehicles/vehicle_brands/honda',
    '/jobs_&_education/education/distance_learning',
    '/business_&_industrial/agriculture_&_forestry/livestock',
    '/arts_&_entertainment/movies/musical_films',
    '/shopping/gifts_&_special_event_items/flowers',
    '/arts_&_entertainment/visual_art_&_design/painting',
    '/finance/investing/brokerages_&_day_trading',
    '/internet_&_telecom/email_&_messaging/text_&_instant_messaging',
    '/computers_&_electronics/consumer_electronics/camera_&_photo_equipment',
    '/games/online_games/massive_multiplayer',
    '/autos_&_vehicles/vehicle_brands/toyota',
    '/pets_&_animals/pets/cats',
    '/shopping/apparel/swimwear',
    '/law_&_government/government/legislative_branch',
    '/law_&_government/legal/legal_education',
    '/people_&_society/religion_&_belief/self-help_&_motivational',
    '/sports/sporting_goods/golf_equipment',
    '/law_&_government/government/public_finance',
    '/autos_&_vehicles/bicycles_&_accessories/bike_frames',
    '/business_&_industrial/energy_&_utilities/water_supply_&_treatment',
    '/arts_&_entertainment/visual_art_&_design/design',
    '/hobbies_&_leisure/outdoors/fishing',
    '/shopping/apparel/sleepwear',
    '/people_&_society/social_issues_&_advocacy/immigration_policy_&_border_issues',
    '/shopping/toys/dolls_&_accessories',
    '/pets_&_animals/pets/exotic_pets',
    '/travel/tourist_destinations/lakes_&_rivers',
    '/finance/financial_planning_&_management/retirement_&_pension',
    '/reference/general_reference/time_&_calendars',
    '/food_&_drink/cooking_&_recipes/salads',
    '/sports/sporting_goods/winter_sports_equipment',
    '/autos_&_vehicles/vehicle_codes_&_driving_laws/vehicle_licensing_&_registration',
    '/home_&_garden/home_furnishings/lamps_&_lighting',
    '/health/vision_care/eye_exams_&_optometry',
    '/games/computer_&_video_games/action_&_platform_games',
    '/computers_&_electronics/electronics_&_electrical/power_supplies',
    '/home_&_garden/kitchen_&_dining/major_kitchen_appliances',
    '/science/biological_sciences/neuroscience',
    '/law_&_government/government/royalty',
    '/pets_&_animals/pets/fish_&_aquaria',
    '/finance/grants_scholarships_&_financial_aid/government_grants',
    '/science/engineering_&_technology/robotics',
    '/home_&_garden/bed_&_bath/bedroom',
    '/arts_&_entertainment/tv_&_video/tv_shows_&_programs',
    '/health/vision_care/laser_vision_correction',
    '/law_&_government/public_safety/emergency_services',
    '/computers_&_electronics/consumer_electronics/tv_&_video_equipment',
    '/games/computer_&_video_games/video_game_development',
    '/reference/humanities/history',
    '/science/ecology_&_environment/climate_change_&_global_warming',
    '/food_&_drink/beverages/soft_drinks',
    '/food_&_drink/food/baked_goods',
    '/food_&_drink/food/dairy_&_eggs',
    '/arts_&_entertainment/music_&_audio/rock_music',
    '/computers_&_electronics/networking/network_monitoring_&_management',
    '/travel/tourist_destinations/zoos-aquariums-preserves',
    '/arts_&_entertainment/performing_arts/magic',
    '/sports/sporting_goods/basketball_equipment',
    '/arts_&_entertainment/music_&_audio/cd_&_audio_shopping',
    '/computers_&_electronics/computer_security/antivirus_&_malware',
    '/news/business_news/fiscal_policy_news',
    '/shopping/apparel/clothing_accessories',
    '/food_&_drink/cooking_&_recipes/healthy_eating',
    '/arts_&_entertainment/humor/live_comedy',
    '/business_&_industrial/transportation_&_logistics/freight_&_trucking',
    '/health/health_conditions/allergies',
    '/business_&_industrial/energy_&_utilities/nuclear_energy',
    '/sports/world_sports_competitions/olympics',
    '/autos_&_vehicles/vehicle_parts_&_accessories/vehicle_wheels_&_tires',
    '/autos_&_vehicles/bicycles_&_accessories/bike_parts_&_repair',
    '/autos_&_vehicles/vehicle_codes_&_driving_laws/vehicle_&_traffic_safety',
    '/sports/sporting_goods/soccer_equipment',
    '/games/card_games/collectible_card_games',
    '/science/biological_sciences/anatomy',
    '/shopping/apparel/eyewear',
    '/arts_&_entertainment/performing_arts/broadway_&_musical_theater',
    '/finance/grants_scholarships_&_financial_aid/study_grants_&_scholarships',
    '/news/politics/opinion_&_commentary',
    '/computers_&_electronics/consumer_electronics/audio_equipment',
    '/law_&_government/government/intelligence_&_counterterrorism',
    '/people_&_society/social_issues_&_advocacy/housing_&_development',
    '/arts_&_entertainment/events_&_listings/live_sporting_events',
    '/law_&_government/government/courts_&_judiciary',
    '/arts_&_entertainment/movies/cult_&_indie_films',
    "/shopping/apparel/men's_clothing",
    '/travel/tourist_destinations/mountain_&_ski_resorts',
    '/business_&_industrial/aerospace_&_defense/space_technology',
    '/sports/individual_sports/track_&_field',
    '/autos_&_vehicles/vehicle_brands/kia',
    '/business_&_industrial/business_operations/human_resources',
    '/computers_&_electronics/computer_hardware/computer_peripherals',
    '/autos_&_vehicles/commercial_vehicles/cargo_trucks_&_trailers',
    '/travel/tourist_destinations/beaches_&_islands',
    '/autos_&_vehicles/vehicle_brands/jeep',
    '/autos_&_vehicles/vehicle_brands/acura',
    '/shopping/apparel/costumes',
    '/finance/investing/derivatives',
    '/pets_&_animals/pets/rabbits_&_rodents',
    '/jobs_&_education/education/training_&_certification',
    '/hobbies_&_leisure/special_occasions/weddings',
    '/business_&_industrial/business_services/writing_&_editing_services',
    '/arts_&_entertainment/movies/comedy_films',
    '/finance/insurance/vehicle_insurance',
    '/autos_&_vehicles/vehicle_brands/porsche',
    '/arts_&_entertainment/music_&_audio/music_equipment_&_technology',
    '/beauty_&_fitness/hair_care/hair_loss',
    '/home_&_garden/home_furnishings/rugs_&_carpets',
    '/games/computer_&_video_games/strategy_games',
    '/beauty_&_fitness/fashion_&_style/fashion_designers_&_collections',
    '/business_&_industrial/energy_&_utilities/oil_&_gas',
    '/computers_&_electronics/computer_hardware/hardware_modding_&_tuning',
    '/reference/libraries_&_museums/libraries',
    '/games/board_games/chess_&_abstract_strategy_games',
    '/food_&_drink/food/herbs_&_spices',
    '/jobs_&_education/education/standardized_&_admissions_tests',
    '/pets_&_animals/pets/birds',
    '/computers_&_electronics/computer_hardware/computer_servers',
    '/autos_&_vehicles/vehicle_brands/nissan',
    '/internet_&_telecom/web_services/hosted_data_storage',
    '/business_&_industrial/energy_&_utilities/waste_management',
    '/computers_&_electronics/software/software_utilities',
    '/arts_&_entertainment/performing_arts/dance',
    '/reference/libraries_&_museums/museums',
    '/arts_&_entertainment/events_&_listings/food_&_beverage_events',
    '/business_&_industrial/metals_&_mining/precious_metals',
    '/finance/accounting_&_auditing/billing_&_invoicing',
    '/law_&_government/legal/constitutional_law_&_civil_rights',
    '/sports/sporting_goods/cricket_equipment',
    '/computers_&_electronics/programming/windows_&_.net',
    '/reference/general_reference/public_records',
    '/online_communities/online_goodies/clip_art_&_animated_gifs',
    '/people_&_society/social_sciences/economics',
    '/internet_&_telecom/mobile_&_wireless/mobile_apps_&_add-ons',
    '/shopping/apparel/apparel_services',
    '/business_&_industrial/chemicals_industry/plastics_&_polymers',
    '/travel/specialty_travel/sightseeing_tours',
    '/arts_&_entertainment/events_&_listings/movie_listings_&_theater_showtimes',
    '/health/public_health/occupational_health_&_safety',
    '/health/health_conditions/ear_nose_&_throat',
    '/finance/insurance/life_insurance',
    '/finance/insurance/travel_insurance',
    '/arts_&_entertainment/movies/classic_films',
    '/travel/specialty_travel/adventure_travel',
    '/arts_&_entertainment/visual_art_&_design/arts_education',
    '/arts_&_entertainment/events_&_listings/event_ticket_sales',
    '/autos_&_vehicles/bicycles_&_accessories/mountain_bikes',
    '/people_&_society/subcultures_&_niche_interests/science_fiction_&_fantasy',
    '/shopping/toys/die-cast_&_toy_vehicles',
    '/hobbies_&_leisure/clubs_&_organizations/fraternal_orders_&_service_clubs',
    '/computers_&_electronics/computer_hardware/computer_components',
    '/reference/general_reference/dictionaries_&_encyclopedias',
    '/news/business_news/economy_news',
    '/travel/tourist_destinations/theme_parks',
    '/hobbies_&_leisure/crafts/ceramics_&_pottery',
    '/science/earth_sciences/water_&_marine_sciences',
    '/shopping/gifts_&_special_event_items/custom_&_personalized_items',
    '/hobbies_&_leisure/outdoors/hiking_&_camping',
    '/business_&_industrial/business_services/e-commerce_services',
    '/arts_&_entertainment/visual_art_&_design/architecture',
    '/shopping/apparel/undergarments',
    '/science/biological_sciences/genetics',
    '/business_&_industrial/industrial_materials_&_equipment/heavy_machinery',
    '/sports/individual_sports/running_&_walking',
    '/hobbies_&_leisure/clubs_&_organizations/youth_organizations_&_resources',
    '/arts_&_entertainment/movies/documentary_films',
    '/finance/investing/stocks_&_bonds',
    '/arts_&_entertainment/visual_art_&_design/photographic_&_digital_arts',
    '/home_&_garden/domestic_services/cleaning_supplies_&_services',
    '/autos_&_vehicles/vehicle_shopping/vehicle_specs_reviews_&_comparisons',
    '/people_&_society/social_sciences/demographics',
    '/arts_&_entertainment/music_&_audio/urban_&_hip-hop',
    '/people_&_society/social_sciences/communications_&_media_studies',
    '/shopping/apparel/uniforms_&_workwear',
    '/arts_&_entertainment/visual_art_&_design/sculpture',
    '/law_&_government/public_safety/security_products_&_services',
    '/hobbies_&_leisure/radio_control_&_modeling/model_trains_&_railroads',
    '/games/computer_&_video_games/shooter_games',
    '/pets_&_animals/animal_products_&_services/veterinarians',
    '/business_&_industrial/construction_&_maintenance/urban_&_regional_planning',
    '/autos_&_vehicles/vehicle_brands/lexus',
    '/beauty_&_fitness/fashion_&_style/fashion_modeling',
    '/beauty_&_fitness/fitness/fitness_equipment_&_accessories',
    '/arts_&_entertainment/movies/romance_films',
    '/sports/water_sports/swimming',
    '/arts_&_entertainment/visual_art_&_design/art_museums_&_galleries',
    '/people_&_society/social_issues_&_advocacy/green_living_&_environmental_issues',
    '/arts_&_entertainment/music_&_audio/country_music',
    '/business_&_industrial/business_services/corporate_events',
    '/sports/motor_sports/motorcycle_racing',
    '/food_&_drink/food_&_grocery_retailers/bakeries',
    '/shopping/gifts_&_special_event_items/cards_&_greetings',
    '/arts_&_entertainment/movies/thriller_crime_&_mystery_films',
    '/games/board_games/miniatures_&_wargaming',
    '/business_&_industrial/agriculture_&_forestry/horticulture',
    '/autos_&_vehicles/trucks_&_suvs/suvs',
    '/autos_&_vehicles/vehicle_brands/chrysler',
    '/law_&_government/legal/legal_services',
    '/computers_&_electronics/networking/vpn_&_remote_access',
    '/hobbies_&_leisure/outdoors/equestrian',
    '/food_&_drink/food/snack_foods',
    '/business_&_industrial/transportation_&_logistics/mail_&_package_delivery',
    '/computers_&_electronics/networking/networking_equipment',
    '/home_&_garden/kitchen_&_dining/cookware_&_diningware',
    '/computers_&_electronics/computer_hardware/computer_drives_&_storage',
    '/science/mathematics/statistics',
    '/computers_&_electronics/consumer_electronics/gps_&_navigation',
    '/games/table_games/table_tennis',
    '/sports/sporting_goods/hockey_equipment',
    '/autos_&_vehicles/vehicle_brands/dodge',
    '/autos_&_vehicles/vehicle_brands/mercedes-benz',
    '/arts_&_entertainment/music_&_audio/vocals_&_show_tunes',
    '/home_&_garden/home_improvement/locks_&_locksmiths',
    '/sports/individual_sports/racquet_sports',
    '/arts_&_entertainment/music_&_audio/classical_music',
    '/home_&_garden/home_improvement/plumbing',
    '/computers_&_electronics/electronics_&_electrical/electromechanical_devices',
    '/food_&_drink/food/condiments_&_dressings',
    '/arts_&_entertainment/music_&_audio/music_education_&_instruction',
    '/home_&_garden/bed_&_bath/bathroom',
    '/law_&_government/government/executive_branch',
    '/jobs_&_education/education/study_abroad',
    '/food_&_drink/food/fruits_&_vegetables',
    '/home_&_garden/home_appliances/water_filters_&_purifiers',
    '/autos_&_vehicles/vehicle_brands/bmw',
    '/arts_&_entertainment/music_&_audio/jazz_&_blues',
    '/law_&_government/government/multilateral_organizations',
    '/health/vision_care/eyeglasses_&_contacts',
    '/autos_&_vehicles/bicycles_&_accessories/bike_helmets_&_protective_gear',
    '/people_&_society/social_issues_&_advocacy/poverty_&_hunger',
    '/home_&_garden/home_improvement/flooring',
    '/beauty_&_fitness/fitness/yoga_&_pilates',
    '/arts_&_entertainment/entertainment_industry/film_&_tv_industry',
    '/science/biological_sciences/flora_&_fauna',
    '/autos_&_vehicles/vehicle_brands/pontiac',
    '/food_&_drink/food/gourmet_&_specialty_foods',
    '/jobs_&_education/jobs/career_resources_&_planning',
    '/sports/sporting_goods/sports_memorabilia',
    '/arts_&_entertainment/events_&_listings/film_festivals',
    '/sports/winter_sports/ice_skating',
    '/reference/geographic_reference/city_&_local_guides',
    '/news/gossip_&_tabloid_news/scandals_&_investigations',
    '/business_&_industrial/hospitality_industry/food_service',
    '/shopping/photo_&_video_services/stock_photography',
    '/arts_&_entertainment/music_&_audio/music_streams_&_downloads',
    '/home_&_garden/home_improvement/doors_&_windows',
    '/people_&_society/social_sciences/international_relations',
    '/finance/accounting_&_auditing/bookkeeping',
    '/people_&_society/social_issues_&_advocacy/discrimination_&_identity_relations',
    '/law_&_government/government/state_&_local_government',
    '/sports/winter_sports/skiing_&_snowboarding',
    '/autos_&_vehicles/vehicle_brands/rolls-royce',
    '/arts_&_entertainment/music_&_audio/music_reference',
    '/games/computer_&_video_games/gaming_media_&_reference',
    '/computers_&_electronics/computer_hardware/laptops_&_notebooks',
    '/sports/individual_sports/cycling',
    '/shopping/toys/stuffed_toys',
    '/computers_&_electronics/networking/data_formats_&_protocols',
    '/food_&_drink/restaurants/fine_dining',
    '/finance/investing/real_estate_investment_trusts',
    '/business_&_industrial/agriculture_&_forestry/agricultural_equipment',
    '/arts_&_entertainment/performing_arts/acting_&_theater',
    '/arts_&_entertainment/online_media/webcams_&_virtual_tours',
    '/shopping/toys/ride-on_toys_&_wagons',
    '/beauty_&_fitness/fitness/bodybuilding',
    '/business_&_industrial/construction_&_maintenance/building_materials_&_supplies',
    '/business_&_industrial/transportation_&_logistics/parking',
    '/autos_&_vehicles/vehicle_brands/cadillac',
    '/business_&_industrial/industrial_materials_&_equipment/generators',
    '/sports/sporting_goods/water_sports_equipment',
    '/law_&_government/legal/criminal_law',
    '/business_&_industrial/transportation_&_logistics/warehousing',
    '/autos_&_vehicles/vehicle_brands/subaru',
    '/business_&_industrial/chemicals_industry/cleaning_agents',
    '/travel/specialty_travel/ecotourism',
    "/shopping/apparel/children's_clothing",
    '/shopping/consumer_resources/identity_theft_&_protection',
    '/games/family-oriented_games_&_activities/drawing_&_coloring',
    '/reference/humanities/philosophy',
    '/autos_&_vehicles/vehicle_brands/vauxhall-opel',
    '/business_&_industrial/construction_&_maintenance/civil_engineering',
    '/people_&_society/social_issues_&_advocacy/human_rights_&_liberties',
    '/games/computer_&_video_games/video_game_emulation',
    '/hobbies_&_leisure/outdoors/hunting_&_shooting',
    '/business_&_industrial/chemicals_industry/dyes_&_pigments',
    '/games/table_games/billiards',
    '/food_&_drink/beverages/juice',
    '/autos_&_vehicles/vehicle_brands/lamborghini',
    '/food_&_drink/food_&_grocery_retailers/convenience_stores',
    '/reference/humanities/myth_&_folklore',
    '/arts_&_entertainment/events_&_listings/bars_clubs_&_nightlife',
    '/hobbies_&_leisure/water_activities/diving_&_underwater_activities',
    '/autos_&_vehicles/vehicle_brands/hyundai',
    '/people_&_society/social_issues_&_advocacy/ethics',
    '/online_communities/photo_&_video_sharing/photo_&_image_sharing',
    '/autos_&_vehicles/bicycles_&_accessories/bike_accessories',
    '/science/earth_sciences/geology',
    '/computers_&_electronics/enterprise_technology/data_management',
    '/computers_&_electronics/enterprise_technology/customer_relationship_management_(crm)',
    '/autos_&_vehicles/vehicle_brands/volkswagen',
    '/internet_&_telecom/web_services/web_design_&_development',
    '/people_&_society/social_issues_&_advocacy/same-sex_marriage',
    '/sports/team_sports/rugby',
    '/internet_&_telecom/web_services/web_stats_&_analytics',
    '/autos_&_vehicles/vehicle_brands/mini',
    '/jobs_&_education/education/vocational_&_continuing_education',
    '/sports/team_sports/australian_football',
    '/food_&_drink/food/jams_jellies_&_preserves',
    '/beauty_&_fitness/cosmetic_procedures/cosmetic_surgery',
    '/internet_&_telecom/service_providers/phone_service_providers',
    '/health/medical_devices_&_equipment/assistive_technology',
    '/business_&_industrial/transportation_&_logistics/packaging',
    '/reference/directories_&_listings/business_&_personal_listings',
    '/shopping/apparel/suits_&_business_attire',
    '/food_&_drink/beverages/bottled_water',
    '/food_&_drink/restaurants/catering',
    '/reference/general_reference/how-to_diy_&_expert_content',
    '/autos_&_vehicles/vehicle_brands/bentley',
    '/business_&_industrial/business_finance/investment_banking',
    '/jobs_&_education/education/primary_&_secondary_schooling_(k-12)',
    '/sports/sporting_goods/table_tennis_equipment',
    '/computers_&_electronics/electronics_&_electrical/electronic_components',
    '/sports/sporting_goods/skateboarding_equipment',
    '/autos_&_vehicles/vehicle_brands/jaguar',
    '/beauty_&_fitness/fitness/fitness_instruction_&_personal_training',
    '/arts_&_entertainment/performing_arts/opera',
    '/sports/team_sports/cheerleading',
    '/business_&_industrial/agriculture_&_forestry/aquaculture',
    '/internet_&_telecom/web_services/search_engine_optimization_&_marketing',
    '/jobs_&_education/jobs/resumes_&_portfolios',
    '/business_&_industrial/transportation_&_logistics/moving_&_relocation',
    '/autos_&_vehicles/vehicle_brands/buick',
    '/computers_&_electronics/programming/java_(programming_language)',
    '/travel/tourist_destinations/historical_sites_&_buildings',
    '/reference/general_reference/biographies_&_quotations',
    '/finance/banking/money_transfer_&_wire_services',
    '/arts_&_entertainment/fun_&_trivia/flash-based_entertainment',
    '/sports/water_sports/surfing',
    '/beauty_&_fitness/fitness/gyms_&_health_clubs',
    '/business_&_industrial/business_services/outsourcing',
    '/shopping/toys/outdoor_toys_&_play_equipment',
    '/home_&_garden/home_improvement/construction_&_power_tools',
    '/home_&_garden/home_furnishings/clocks',
    '/sports/sporting_goods/bowling_equipment',
    '/sports/individual_sports/gymnastics',
    '/home_&_garden/home_improvement/house_painting_&_finishing',
    '/arts_&_entertainment/performing_arts/circus',
    '/autos_&_vehicles/vehicle_parts_&_accessories/vehicle_fuels_&_lubricants',
    '/arts_&_entertainment/online_media/online_image_galleries',
    '/business_&_industrial/business_finance/commercial_lending',
    '/business_&_industrial/advertising_&_marketing/telemarketing',
    '/arts_&_entertainment/offbeat/occult_&_paranormal',
    '/autos_&_vehicles/vehicle_brands/audi',
    '/games/computer_&_video_games/music_&_dance_games',
    '/finance/financial_planning_&_management/asset_&_portfolio_management',
    '/autos_&_vehicles/vehicle_parts_&_accessories/engine_&_transmission',
    '/autos_&_vehicles/vehicle_brands/gm-daewoo',
    '/arts_&_entertainment/humor/spoofs_&_satire',
    '/games/computer_&_video_games/adventure_games',
    '/business_&_industrial/chemicals_industry/coatings_&_adhesives',
    '/finance/investing/funds',
    '/travel/tourist_destinations/regional_parks_&_gardens',
    '/games/computer_&_video_games/simulation_games',
    '/sports/sporting_goods/combat_sports_equipment',
    '/law_&_government/government/government_agencies',
    '/autos_&_vehicles/vehicle_brands/land_rover',
    "/health/medical_facilities_&_services/doctors'_offices",
    '/reference/general_reference/educational_resources',
    '/online_communities/blogging_resources_&_services/microblogging',
    '/arts_&_entertainment/music_&_audio/music_videos',
    '/sports/individual_sports/skate_sports',
    '/online_communities/dating_&_personals/personals',
    '/business_&_industrial/small_business/mlm_&_business_opportunities',
    '/law_&_government/government/lobbying',
    '/autos_&_vehicles/vehicle_brands/mazda',
    '/autos_&_vehicles/vehicle_brands/fiat',
    '/computers_&_electronics/electronics_&_electrical/optoelectronics_&_fiber',
    '/sports/sporting_goods/roller_skating_&_rollerblading_equipment',
    '/law_&_government/legal/bankruptcy',
    '/business_&_industrial/business_finance/venture_capital',
    '/autos_&_vehicles/vehicle_brands/mitsubishi',
    '/science/computer_science/distributed_&_parallel_computing',
    '/autos_&_vehicles/trucks_&_suvs/vans_&_minivans',
    '/business_&_industrial/transportation_&_logistics/public_storage',
    '/sports/sporting_goods/tennis_equipment',
    '/autos_&_vehicles/bicycles_&_accessories/bmx_bikes',
    '/autos_&_vehicles/bicycles_&_accessories/road_bikes',
    '/autos_&_vehicles/vehicle_brands/maserati',
    '/business_&_industrial/business_services/quality_control_&_tracking',
    '/autos_&_vehicles/vehicle_brands/saab',
    '/arts_&_entertainment/movies/drama_films',
    '/finance/financial_planning_&_management/inheritance_&_estate_planning',
    '/arts_&_entertainment/music_&_audio/folk_&_traditional_music',
    '/shopping/consumer_resources/consumer_advocacy_&_protection',
    '/business_&_industrial/business_finance/risk_management',
    '/travel/specialty_travel/agritourism',
    '/business_&_industrial/business_services/consulting',
    '/home_&_garden/kitchen_&_dining/small_kitchen_appliances',
    '/computers_&_electronics/software/open_source',
    '/internet_&_telecom/web_services/web_hosting_&_domain_registration',
    '/home_&_garden/home_improvement/roofing',
    '/people_&_society/social_sciences/anthropology',
    '/people_&_society/subcultures_&_niche_interests/goth_subculture',
    '/internet_&_telecom/service_providers/isps',
    '/business_&_industrial/transportation_&_logistics/urban_transport',
    'mask',
    null,
  ],
  time_of_day: ['others', 'Evening', 'Afternoon', 'Noon', 'Morning', 'mask', null],
}
